// I Type globali sono automaticamente inclusi tramite tsconfig.json

export class FpiMemO28 {
  private readonly controllerPath: string = "front"
  private currentActiveForm: string = "1"
  private currentStepKey: string = ""
  private total_steps!: number // Verrà calcolato dinamicamente dai form presenti nel DOM
  private stepsConfig: Array<{ [key: string]: any }> = []
  private formId: string | null = null

  constructor() {
    console.log("FpiMemO28 module initialized")
  }

  public init(): void {
    console.log("Initializing FpiMemO28 module")
    this.getStepConfig()
    this.calculateTotalSteps()
    this.setupEventListeners()
    this.initializeComponents()
  }

  /**
   * Recupero le informazioni del file di configurazione
   */

  private getStepConfig(): void {
    const container = document.getElementById("fpi-mem028-container")
    const configData = container?.getAttribute("data-config")
    if (configData) {
      this.stepsConfig = JSON.parse(configData)
      this.currentStepKey = this.stepsConfig[1]["key"]
      // Leggo il form_id dal container (vuoto = nuovo form)
      const formIdAttr = container?.getAttribute("data-form-id")
      this.formId = formIdAttr && formIdAttr !== "" ? formIdAttr : null
      return
    }
    console.error("Missing FpiMemO28 configuration data")
  }

  /**
   * Ottiene il Base URL dal meta tag (sicuro)
   */
  private getBaseUrl(): string {
    const metaTag = document.querySelector('meta[name="base-url"]') as HTMLMetaElement
    return metaTag?.content || ""
  }

  /**
   * Calcola dinamicamente il numero totale di step basandosi sui form-part presenti nel DOM
   */
  private calculateTotalSteps(): void {
    this.total_steps = Object.keys(this.stepsConfig).length
    // console.log(`Total steps calculated from config: ${this.total_steps}`)
  }

  private setupEventListeners(): void {
    console.log("Setting up FpiMemO28 event listeners")

    // Gestisco i click sui link della lista form
    this.setupFormNavigation()

    // Gestisco i submit dei form
    this.setupFormSubmission()

    // Gestisco il download del documento per step 2
    this.setupDocumentationDownload()

    // Gestisco la selezione documenti per step 3
    this.setupDocumentSelection()

    // Gestisco i click sulle righe dei documenti per toggle delle checkbox
    this.setupDocumentRowClickHandlers()

    // Gestisco i calcoli automatici per Step 7
    this.setupStep7Calculations()

    // Gestisco le richieste multiple per Step 6
    // Solo il setup iniziale del pulsante Add, i remove sono gestiti globalmente
    this.setupStep6RequestHandlers()

    // Gestisco i pulsanti per rimuovere le richieste (delegated event listener globale)
    this.setupGlobalStep6RemoveHandlers()
  }

  private setupFormSubmission(): void {
    // Intercetto tutti i submit dei form all'interno dei form-part
    const formParts = document.querySelectorAll(".form-part")

    formParts.forEach(formPart => {
      const forms = formPart.querySelectorAll("form")

      forms.forEach(form => {
        form.addEventListener("submit", e => {
          e.preventDefault()
          // Rimuovo eventuali messaggi di errore precedenti
          const errorAlert = document.querySelector(".alert-danger")
          if (errorAlert) {
            errorAlert.remove()
          }
          // Determino lo step corrente dal form-part parent
          const formPartId = formPart.id
          const stepNumber = formPartId.replace("form-part-", "")

          console.log(`Form submitted for step ${stepNumber}`)
          this.handleFormSave(form as HTMLFormElement, stepNumber)
        })
      })
    })

    console.log(`Set up form submission for ${formParts.length} form parts`)
  }

  private setupDocumentationDownload(): void {
    const downloadBtn = document.getElementById("downloadDocumentationBtn")
    const regionId = downloadBtn?.getAttribute("data-id_region") || null
    if (!regionId) {
      console.error("Region ID not found")
      return
    }
    const documentName = `Structure and delivery of documentation - ${regionId}.pdf`
    if (downloadBtn) {
      downloadBtn.addEventListener("click", e => {
        e.preventDefault()
        console.log("Documentation view initiated")
        const baseUrl = this.getBaseUrl()
        // Apro il PDF in una nuova finestra
        const documentUrl = `${baseUrl}/assets/front/documents/${documentName}`
        window.open(documentUrl, "_blank")

        // Abilito la checkbox di conferma
        this.enableDocumentationConfirmation()
      })

      console.log("Documentation download handler set up")
    }
  }

  private enableDocumentationConfirmation(): void {
    const confirmationGroup = document.getElementById("confirmationGroup")
    const checkbox = document.getElementById("documentationViewedCheck") as HTMLInputElement

    if (confirmationGroup && checkbox) {
      // Mostro il gruppo di conferma
      confirmationGroup.style.display = "block"

      // Abilito la checkbox
      checkbox.disabled = false

      // Aggiungo un'animazione di evidenziazione
      confirmationGroup.classList.add("highlight-animation")

      // Rimuovo l'animazione dopo un po'
      setTimeout(() => {
        confirmationGroup.classList.remove("highlight-animation")
      }, 2000)

      console.log("Documentation confirmation enabled")
    }
  }

  private setupDocumentSelection(): void {
    // Gestisco i cambiamenti delle checkbox dei documenti
    const documentCheckboxes = document.querySelectorAll('input[name="selected_documents[]"]')

    documentCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", () => {
        this.updateDocumentSelectionUI()
      })
    })

    // Inizializzo la UI con lo stato corrente
    this.updateDocumentSelectionUI()

    console.log(`Set up document selection for ${documentCheckboxes.length} documents`)
  }

  private updateDocumentSelectionUI(): void {
    const selectedCheckboxes = document.querySelectorAll('input[name="selected_documents[]"]:checked')
    const summary = document.getElementById("selectedDocumentsSummary")
    const summaryList = document.getElementById("selectedDocumentsList")
    const alert = document.getElementById("documentSelectionAlert")

    if (selectedCheckboxes.length > 0) {
      // Nascondo l'alert di errore
      if (alert) {
        alert.style.display = "none"
      }

      // Mostro il summary
      if (summary) {
        summary.style.display = "block"
      }

      // Aggiorno la lista dei documenti selezionati
      if (summaryList) {
        summaryList.innerHTML = ""

        selectedCheckboxes.forEach(checkbox => {
          const input = checkbox as HTMLInputElement
          const code = input.getAttribute("data-code") || "NA"
          const description = input.getAttribute("data-description") || "No description"

          const itemDiv = document.createElement("div")
          itemDiv.className = "selected-document-item"
          itemDiv.innerHTML = `
            <span class="document-code">${code}</span>
            <span class="document-description">${description}</span>
          `

          summaryList.appendChild(itemDiv)
        })
      }
    } else {
      // Nascondo il summary se nessun documento è selezionato
      if (summary) {
        summary.style.display = "none"
      }
    }
  }

  private setupFormNavigation(): void {
    const formLinks = document.querySelectorAll(".list-group-item[data-form]")

    formLinks.forEach(link => {
      link.addEventListener("click", e => {
        e.preventDefault()

        // Controllo se l'elemento è disabled
        if (link.classList.contains("disabled")) {
          console.log("Form step is disabled")
          return
        }

        const formNumber = (e.target as HTMLElement).getAttribute("data-form")
        if (formNumber) {
          this.switchToForm(formNumber)
        }
      })
    })

    console.log(`Set up navigation for ${formLinks.length} form links`)
  }

  private setupDocumentRowClickHandlers(): void {
    // Gestione click sulla riga del documento per toggle della checkbox (Step 3 e Step 2)
    const documentRows = document.querySelectorAll(".document-selection-row")

    documentRows.forEach(row => {
      row.addEventListener("click", (e: Event) => {
        // Previeni il doppio click se si clicca direttamente sulla checkbox
        const target = e.target as HTMLElement
        if (target.tagName === "INPUT" && (target as HTMLInputElement).type === "checkbox") {
          return
        }

        const checkbox = row.querySelector('input[type="checkbox"]') as HTMLInputElement
        if (checkbox && !checkbox.disabled) {
          // Controllo aggiuntivo per checkbox disabilitate
          checkbox.checked = !checkbox.checked
          // Trigger change event per mantenere la compatibilità con altri script
          checkbox.dispatchEvent(
            new Event("change", {
              bubbles: true
            })
          )
        }
      })

      // Aggiunge cursore pointer per indicare che è cliccabile (solo se la checkbox non è disabilitata)
      const checkbox = row.querySelector('input[type="checkbox"]') as HTMLInputElement
      if (checkbox && !checkbox.disabled) {
        ;(row as HTMLElement).style.cursor = "pointer"
      }
    })

    console.log(`Set up document row click handlers for ${documentRows.length} rows`)
  }

  private setupStep7Calculations(): void {
    // Setup calcoli automatici per working_hours_year
    this.setupWorkingHoursCalculation()

    // Setup calcoli automatici per wheel dressing
    this.setupWheelDressingCalculations()

    // Setup calcoli automatici per total machine time
    this.setupTotalMachineTimeCalculation()

    // Setup calcoli automatici per equivalent machine time
    this.setupEquivalentMachineTimeCalculation()

    // Setup calcoli automatici per hourly output
    this.setupHourlyOutputCalculation()

    // Setup calcoli automatici per tool change piece incidence
    this.setupToolChangePieceIncidenceCalculation()

    // Setup calcoli automatici per other activities piece incidence
    this.setupOtherActivitiesPieceIncidenceCalculation()

    // Setup calcoli automatici per scheduled maintenance piece incidence
    this.setupScheduledMaintenancePieceIncidenceCalculation()

    // Setup calcoli automatici per malfunctions piece incidence
    this.setupMalfunctionsPieceIncidenceCalculation()

    // Setup calcoli automatici per other activities efficiency percentage
    this.setupOtherActivitiesEfficiencyCalculation()

    // Setup calcoli automatici per scheduled maintenance efficiency percentage
    this.setupScheduledMaintenanceEfficiencyCalculation()

    // Setup calcoli automatici per malfunctions efficiency percentage
    this.setupMalfunctionsEfficiencyCalculation()

    // Setup calcoli automatici per technical efficiency
    this.setupTechnicalEfficiencyCalculation()

    // Setup calcoli automatici per hourly output finale
    this.setupFinalHourlyOutputCalculation()

    // Setup calcoli automatici per tool change efficiency percentage
    this.setupToolChangeEfficiencyCalculation()

    console.log("Set up Step 7 automatic calculations")
  }

  private setupWorkingHoursCalculation(): void {
    // Campi input per i calcoli automatici working_hours_year
    const hoursPerShiftInput = document.querySelector('input[name="hours_per_shift"]') as HTMLInputElement
    const shiftsPerDayInput = document.querySelector('input[name="shifts_per_day"]') as HTMLInputElement
    const workingDaysYearInput = document.querySelector('input[name="working_days_year"]') as HTMLInputElement
    const workingHoursYearInput = document.querySelector('input[name="working_hours_year"]') as HTMLInputElement

    // Se non siamo in Step 7, non aggiungo i listener
    if (!hoursPerShiftInput || !shiftsPerDayInput || !workingDaysYearInput || !workingHoursYearInput) {
      console.log("Step 7 working hours inputs not found, skipping calculations setup")
      return
    }

    // Funzione per calcolare working_hours_year
    const calculateWorkingHoursYear = (): void => {
      const hoursPerShift = parseFloat(hoursPerShiftInput.value) || 0
      const shiftsPerDay = parseFloat(shiftsPerDayInput.value) || 0
      const workingDaysYear = parseFloat(workingDaysYearInput.value) || 0

      // Formula: hours_per_shift × shifts_per_day × working_days_year
      const workingHoursYear = hoursPerShift * shiftsPerDay * workingDaysYear

      // Aggiorno il campo readonly
      workingHoursYearInput.value = workingHoursYear.toString()

      // console.log(
      //   `Calculated working_hours_year: ${workingHoursYear} (${hoursPerShift} x ${shiftsPerDay} x ${workingDaysYear})`
      // )
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    hoursPerShiftInput.removeEventListener("input", calculateWorkingHoursYear)
    hoursPerShiftInput.removeEventListener("change", calculateWorkingHoursYear)
    shiftsPerDayInput.removeEventListener("input", calculateWorkingHoursYear)
    shiftsPerDayInput.removeEventListener("change", calculateWorkingHoursYear)
    workingDaysYearInput.removeEventListener("input", calculateWorkingHoursYear)
    workingDaysYearInput.removeEventListener("change", calculateWorkingHoursYear)

    // Aggiungo event listeners sui campi input
    hoursPerShiftInput.addEventListener("input", calculateWorkingHoursYear)
    hoursPerShiftInput.addEventListener("change", calculateWorkingHoursYear)

    shiftsPerDayInput.addEventListener("input", calculateWorkingHoursYear)
    shiftsPerDayInput.addEventListener("change", calculateWorkingHoursYear)

    workingDaysYearInput.addEventListener("input", calculateWorkingHoursYear)
    workingDaysYearInput.addEventListener("change", calculateWorkingHoursYear)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateWorkingHoursYear()

    console.log("Set up working_hours_year automatic calculation")
  }

  private setupWheelDressingCalculations(): void {
    // Setup per ogni ruota (Wheel 1, 2, 3)
    for (let wheelNum = 1; wheelNum <= 3; wheelNum++) {
      this.setupSingleWheelCalculation(wheelNum)
    }

    // Setup per il calcolo del totale
    this.setupTotalDressingCalculation()
  }

  private setupSingleWheelCalculation(wheelNumber: number): void {
    const frequencyInput = document.querySelector(`input[name="wheel${wheelNumber}_frequency"]`) as HTMLInputElement
    const timeInput = document.querySelector(`input[name="wheel${wheelNumber}_time"]`) as HTMLInputElement
    const dressingPerPieceInput = document.querySelector(
      `input[name="wheel${wheelNumber}_dressing_per_piece"]`
    ) as HTMLInputElement

    // Se non troviamo tutti i campi necessari per questa ruota, skippiamo
    if (!frequencyInput || !timeInput || !dressingPerPieceInput) {
      console.log(`Wheel ${wheelNumber} inputs not found, skipping calculation setup`)
      return
    }

    // Funzione per calcolare dressing per piece per questa ruota
    const calculateDressingPerPiece = (): void => {
      const frequency = parseFloat(frequencyInput.value) || 0
      const time = parseFloat(timeInput.value) || 0

      let dressingPerPiece = 0
      if (frequency > 0 && time > 0) {
        // Formula: time / frequency
        dressingPerPiece = time / frequency
      }

      // Aggiorno il campo readonly con 2 decimali di precisione
      dressingPerPieceInput.value = dressingPerPiece.toFixed(2)

      // console.log(
      //   `Calculated wheel${wheelNumber}_dressing_per_piece: ${dressingPerPiece.toFixed(2)} (${time} / ${frequency})`
      // )

      // Trigger calcolo del totale
      this.calculateTotalDressingTime()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    frequencyInput.removeEventListener("input", calculateDressingPerPiece)
    frequencyInput.removeEventListener("change", calculateDressingPerPiece)
    timeInput.removeEventListener("input", calculateDressingPerPiece)
    timeInput.removeEventListener("change", calculateDressingPerPiece)

    // Aggiungo event listeners sui campi input
    frequencyInput.addEventListener("input", calculateDressingPerPiece)
    frequencyInput.addEventListener("change", calculateDressingPerPiece)
    timeInput.addEventListener("input", calculateDressingPerPiece)
    timeInput.addEventListener("change", calculateDressingPerPiece)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateDressingPerPiece()

    console.log(`Set up wheel ${wheelNumber} dressing calculations`)
  }

  private setupTotalDressingCalculation(): void {
    // Questa funzione viene chiamata ogni volta che cambia un valore di dressing per piece
    // Il calcolo effettivo è gestito da calculateTotalDressingTime()
    console.log("Set up total dressing calculation")
  }

  private calculateTotalDressingTime(): void {
    const wheel1Input = document.querySelector('input[name="wheel1_dressing_per_piece"]') as HTMLInputElement
    const wheel2Input = document.querySelector('input[name="wheel2_dressing_per_piece"]') as HTMLInputElement
    const wheel3Input = document.querySelector('input[name="wheel3_dressing_per_piece"]') as HTMLInputElement
    const totalInput = document.querySelector('input[name="total_dressing_time"]') as HTMLInputElement

    if (!totalInput) {
      console.log("Total dressing time input not found")
      return
    }

    const wheel1Value = parseFloat(wheel1Input?.value || "0") || 0
    const wheel2Value = parseFloat(wheel2Input?.value || "0") || 0
    const wheel3Value = parseFloat(wheel3Input?.value || "0") || 0

    const total = wheel1Value + wheel2Value + wheel3Value

    // Aggiorno il campo readonly del totale
    totalInput.value = total.toFixed(2)

    // console.log(
    //   `Calculated total_dressing_time: ${total.toFixed(2)} (${wheel1Value} + ${wheel2Value} + ${wheel3Value})`
    // )

    // Trigger calcolo del total machine time
    this.calculateTotalMachineTime()
  }

  private setupTotalMachineTimeCalculation(): void {
    // Setup calcoli automatici per total_machine_time
    const activeMachineTimeInput = document.querySelector('input[name="active_machine_time"]') as HTMLInputElement
    const inactiveMachineTimeInput = document.querySelector('input[name="inactive_machine_time"]') as HTMLInputElement
    const totalDressingTimeInput = document.querySelector('input[name="total_dressing_time"]') as HTMLInputElement

    // Se non troviamo tutti i campi necessari, skippiamo
    if (!activeMachineTimeInput || !inactiveMachineTimeInput || !totalDressingTimeInput) {
      console.log("Total machine time inputs not found, skipping calculation setup")
      return
    }

    // Funzione per calcolare total machine time
    const calculateTotalMachineTime = (): void => {
      this.calculateTotalMachineTime()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    activeMachineTimeInput.removeEventListener("input", calculateTotalMachineTime)
    activeMachineTimeInput.removeEventListener("change", calculateTotalMachineTime)
    inactiveMachineTimeInput.removeEventListener("input", calculateTotalMachineTime)
    inactiveMachineTimeInput.removeEventListener("change", calculateTotalMachineTime)

    // Aggiungo event listeners sui campi input
    activeMachineTimeInput.addEventListener("input", calculateTotalMachineTime)
    activeMachineTimeInput.addEventListener("change", calculateTotalMachineTime)
    inactiveMachineTimeInput.addEventListener("input", calculateTotalMachineTime)
    inactiveMachineTimeInput.addEventListener("change", calculateTotalMachineTime)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateTotalMachineTime()

    console.log("Set up total machine time automatic calculation")
  }

  private calculateTotalMachineTime(): void {
    const activeMachineTimeInput = document.querySelector('input[name="active_machine_time"]') as HTMLInputElement
    const inactiveMachineTimeInput = document.querySelector('input[name="inactive_machine_time"]') as HTMLInputElement
    const totalDressingTimeInput = document.querySelector('input[name="total_dressing_time"]') as HTMLInputElement
    const totalMachineTimeInput = document.querySelector('input[name="total_machine_time"]') as HTMLInputElement

    if (!totalMachineTimeInput) {
      console.log("Total machine time input not found")
      return
    }

    const activeMachineTime = parseFloat(activeMachineTimeInput?.value || "0") || 0
    const inactiveMachineTime = parseFloat(inactiveMachineTimeInput?.value || "0") || 0
    const totalDressingTime = parseFloat(totalDressingTimeInput?.value || "0") || 0

    // Formula: active_machine_time + inactive_machine_time + total_dressing_time
    const totalMachineTime = activeMachineTime + inactiveMachineTime + totalDressingTime

    // Aggiorno il campo readonly del totale
    totalMachineTimeInput.value = totalMachineTime.toFixed(2)

    // console.log(
    //   `Calculated total_machine_time: ${totalMachineTime.toFixed(2)} (${activeMachineTime} + ${inactiveMachineTime} + ${totalDressingTime})`
    // )

    // Trigger calcolo dell'equivalent machine time
    this.calculateEquivalentMachineTime()
  }

  private setupEquivalentMachineTimeCalculation(): void {
    // Setup calcoli automatici per equivalent_machine_time
    const totalMachineTimeInput = document.querySelector('input[name="total_machine_time"]') as HTMLInputElement
    const piecesSimultaneousInput = document.querySelector('input[name="pieces_simultaneous"]') as HTMLInputElement

    // Se non troviamo tutti i campi necessari, skippiamo
    if (!totalMachineTimeInput || !piecesSimultaneousInput) {
      console.log("Equivalent machine time inputs not found, skipping calculation setup")
      return
    }

    // Funzione per calcolare equivalent machine time
    const calculateEquivalentMachineTime = (): void => {
      this.calculateEquivalentMachineTime()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    piecesSimultaneousInput.removeEventListener("input", calculateEquivalentMachineTime)
    piecesSimultaneousInput.removeEventListener("change", calculateEquivalentMachineTime)

    // Aggiungo event listeners sui campi input
    piecesSimultaneousInput.addEventListener("input", calculateEquivalentMachineTime)
    piecesSimultaneousInput.addEventListener("change", calculateEquivalentMachineTime)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateEquivalentMachineTime()

    console.log("Set up equivalent machine time automatic calculation")
  }

  private calculateEquivalentMachineTime(): void {
    const totalMachineTimeInput = document.querySelector('input[name="total_machine_time"]') as HTMLInputElement
    const piecesSimultaneousInput = document.querySelector('input[name="pieces_simultaneous"]') as HTMLInputElement
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement

    if (!equivalentMachineTimeInput) {
      console.log("Equivalent machine time input not found")
      return
    }

    const totalMachineTime = parseFloat(totalMachineTimeInput?.value || "0") || 0
    const piecesSimultaneous = parseFloat(piecesSimultaneousInput?.value || "1") || 1 // Default a 1 per evitare divisione per zero

    // Formula: total_machine_time / pieces_simultaneous
    const equivalentMachineTime = totalMachineTime / piecesSimultaneous

    // Aggiorno il campo readonly del risultato
    equivalentMachineTimeInput.value = equivalentMachineTime.toFixed(2)

    // console.log(
    //   `Calculated equivalent_machine_time: ${equivalentMachineTime.toFixed(2)} (${totalMachineTime} / ${piecesSimultaneous})`
    // )

    // Dopo aver calcolato equivalent_machine_time, calcolo anche hourly_output e tool_change_efficiency
    this.calculateHourlyOutput()
    this.calculateToolChangeEfficiency()
    this.calculateOtherActivitiesEfficiency()
    this.calculateScheduledMaintenanceEfficiency()
    this.calculateMalfunctionsEfficiency()
  }

  private setupHourlyOutputCalculation(): void {
    // Setup calcoli automatici per machine_time_cycle_operation_hourly_output
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement

    // Se non troviamo il campo necessario, skippiamo
    if (!equivalentMachineTimeInput) {
      console.log("Equivalent machine time input not found, skipping hourly output calculation setup")
      return
    }

    // Il calcolo hourly output è triggerato dal calcolo di equivalent_machine_time
    // quindi non aggiungiamo listener aggiuntivi qui

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateHourlyOutput()

    console.log("Set up hourly output automatic calculation")
  }

  private calculateHourlyOutput(): void {
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement
    const hourlyOutputInput = document.querySelector(
      'input[name="machine_time_cycle_operation_hourly_output"]'
    ) as HTMLInputElement

    if (!hourlyOutputInput) {
      console.log("Hourly output input not found")
      return
    }

    const equivalentMachineTime = parseFloat(equivalentMachineTimeInput?.value || "0") || 0

    // Formula: 60 / equivalent_machine_time
    // Se equivalent_machine_time è 0, imposto hourly output a 0 per evitare divisione per zero
    const hourlyOutput = equivalentMachineTime > 0 ? 60 / equivalentMachineTime : 0

    // Aggiorno il campo readonly del risultato
    hourlyOutputInput.value = hourlyOutput.toFixed(2)

    // console.log(`Calculated hourly_output: ${hourlyOutput.toFixed(2)} (60 / ${equivalentMachineTime})`)

    // Dopo aver calcolato machine_time_cycle_operation_hourly_output, ricalcolo anche final hourly output
    this.calculateFinalHourlyOutput()
  }

  private setupToolChangePieceIncidenceCalculation(): void {
    // Setup calcoli automatici per tool_change_piece_incidence
    const toolChangeAverageTimeInput = document.querySelector(
      'input[name="tool_change_average_time"]'
    ) as HTMLInputElement
    const toolChangeAveragePeriodInput = document.querySelector(
      'input[name="tool_change_average_period"]'
    ) as HTMLInputElement

    // Se non troviamo tutti i campi necessari, skippiamo
    if (!toolChangeAverageTimeInput || !toolChangeAveragePeriodInput) {
      console.log("Tool change inputs not found, skipping piece incidence calculation setup")
      return
    }

    // Funzione per calcolare tool change piece incidence
    const calculateToolChangePieceIncidence = (): void => {
      this.calculateToolChangePieceIncidence()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    toolChangeAverageTimeInput.removeEventListener("input", calculateToolChangePieceIncidence)
    toolChangeAverageTimeInput.removeEventListener("change", calculateToolChangePieceIncidence)
    toolChangeAveragePeriodInput.removeEventListener("input", calculateToolChangePieceIncidence)
    toolChangeAveragePeriodInput.removeEventListener("change", calculateToolChangePieceIncidence)

    // Aggiungo event listeners sui campi input
    toolChangeAverageTimeInput.addEventListener("input", calculateToolChangePieceIncidence)
    toolChangeAverageTimeInput.addEventListener("change", calculateToolChangePieceIncidence)
    toolChangeAveragePeriodInput.addEventListener("input", calculateToolChangePieceIncidence)
    toolChangeAveragePeriodInput.addEventListener("change", calculateToolChangePieceIncidence)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateToolChangePieceIncidence()

    console.log("Set up tool change piece incidence automatic calculation")
  }

  private calculateToolChangePieceIncidence(): void {
    const toolChangeAverageTimeInput = document.querySelector(
      'input[name="tool_change_average_time"]'
    ) as HTMLInputElement
    const toolChangeAveragePeriodInput = document.querySelector(
      'input[name="tool_change_average_period"]'
    ) as HTMLInputElement
    const toolChangePieceIncidenceInput = document.querySelector(
      'input[name="tool_change_piece_incidence"]'
    ) as HTMLInputElement

    if (!toolChangePieceIncidenceInput) {
      console.log("Tool change piece incidence input not found")
      return
    }

    const averageTime = parseFloat(toolChangeAverageTimeInput?.value || "0") || 0
    const averagePeriod = parseFloat(toolChangeAveragePeriodInput?.value || "1") || 1 // Default a 1 per evitare divisione per zero

    // Formula: tool_change_average_time / tool_change_average_period
    const pieceIncidence = averageTime / averagePeriod

    // Aggiorno il campo readonly del risultato
    toolChangePieceIncidenceInput.value = pieceIncidence.toFixed(2)

    // console.log(
    //   `Calculated tool_change_piece_incidence: ${pieceIncidence.toFixed(2)} (${averageTime} / ${averagePeriod})`
    // )

    // Dopo aver calcolato tool_change_piece_incidence, calcolo anche tool_change_efficiency
    this.calculateToolChangeEfficiency()
    this.calculateOtherActivitiesEfficiency()
    this.calculateScheduledMaintenanceEfficiency()
    this.calculateMalfunctionsEfficiency()
  }

  private setupOtherActivitiesPieceIncidenceCalculation(): void {
    // Setup calcoli automatici per other_activities_piece_incidence
    const otherActivitiesAverageTimeInput = document.querySelector(
      'input[name="other_activities_average_time"]'
    ) as HTMLInputElement
    const otherActivitiesAveragePeriodInput = document.querySelector(
      'input[name="other_activities_average_period"]'
    ) as HTMLInputElement

    // Se non troviamo tutti i campi necessari, skippiamo
    if (!otherActivitiesAverageTimeInput || !otherActivitiesAveragePeriodInput) {
      console.log("Other activities inputs not found, skipping piece incidence calculation setup")
      return
    }

    // Funzione per calcolare other activities piece incidence
    const calculateOtherActivitiesPieceIncidence = (): void => {
      this.calculateOtherActivitiesPieceIncidence()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    otherActivitiesAverageTimeInput.removeEventListener("input", calculateOtherActivitiesPieceIncidence)
    otherActivitiesAverageTimeInput.removeEventListener("change", calculateOtherActivitiesPieceIncidence)
    otherActivitiesAveragePeriodInput.removeEventListener("input", calculateOtherActivitiesPieceIncidence)
    otherActivitiesAveragePeriodInput.removeEventListener("change", calculateOtherActivitiesPieceIncidence)

    // Aggiungo event listeners sui campi input
    otherActivitiesAverageTimeInput.addEventListener("input", calculateOtherActivitiesPieceIncidence)
    otherActivitiesAverageTimeInput.addEventListener("change", calculateOtherActivitiesPieceIncidence)
    otherActivitiesAveragePeriodInput.addEventListener("input", calculateOtherActivitiesPieceIncidence)
    otherActivitiesAveragePeriodInput.addEventListener("change", calculateOtherActivitiesPieceIncidence)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateOtherActivitiesPieceIncidence()

    console.log("Set up other activities piece incidence automatic calculation")
  }

  private calculateOtherActivitiesPieceIncidence(): void {
    const otherActivitiesAverageTimeInput = document.querySelector(
      'input[name="other_activities_average_time"]'
    ) as HTMLInputElement
    const otherActivitiesAveragePeriodInput = document.querySelector(
      'input[name="other_activities_average_period"]'
    ) as HTMLInputElement
    const otherActivitiesPieceIncidenceInput = document.querySelector(
      'input[name="other_activities_piece_incidence"]'
    ) as HTMLInputElement

    if (!otherActivitiesPieceIncidenceInput) {
      console.log("Other activities piece incidence input not found")
      return
    }

    const averageTime = parseFloat(otherActivitiesAverageTimeInput?.value || "0") || 0
    const averagePeriod = parseFloat(otherActivitiesAveragePeriodInput?.value || "1") || 1 // Default a 1 per evitare divisione per zero

    // Formula: other_activities_average_time / other_activities_average_period
    const pieceIncidence = averageTime / averagePeriod

    // Aggiorno il campo readonly del risultato
    otherActivitiesPieceIncidenceInput.value = pieceIncidence.toFixed(2)

    // console.log(
    //   `Calculated other_activities_piece_incidence: ${pieceIncidence.toFixed(2)} (${averageTime} / ${averagePeriod})`
    // )

    // Dopo aver calcolato other_activities_piece_incidence, calcolo anche tool_change_efficiency
    this.calculateToolChangeEfficiency()
    this.calculateOtherActivitiesEfficiency()
    this.calculateScheduledMaintenanceEfficiency()
    this.calculateMalfunctionsEfficiency()
  }

  private setupScheduledMaintenancePieceIncidenceCalculation(): void {
    // Setup calcoli automatici per scheduled_maintenance_piece_incidence
    const scheduledMaintenanceAverageTimeInput = document.querySelector(
      'input[name="scheduled_maintenance_average_time"]'
    ) as HTMLInputElement
    const scheduledMaintenanceAveragePeriodInput = document.querySelector(
      'input[name="scheduled_maintenance_average_period"]'
    ) as HTMLInputElement

    // Se non troviamo tutti i campi necessari, skippiamo
    if (!scheduledMaintenanceAverageTimeInput || !scheduledMaintenanceAveragePeriodInput) {
      console.log("Scheduled maintenance inputs not found, skipping piece incidence calculation setup")
      return
    }

    // Funzione per calcolare scheduled maintenance piece incidence
    const calculateScheduledMaintenancePieceIncidence = (): void => {
      this.calculateScheduledMaintenancePieceIncidence()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    scheduledMaintenanceAverageTimeInput.removeEventListener("input", calculateScheduledMaintenancePieceIncidence)
    scheduledMaintenanceAverageTimeInput.removeEventListener("change", calculateScheduledMaintenancePieceIncidence)
    scheduledMaintenanceAveragePeriodInput.removeEventListener("input", calculateScheduledMaintenancePieceIncidence)
    scheduledMaintenanceAveragePeriodInput.removeEventListener("change", calculateScheduledMaintenancePieceIncidence)

    // Aggiungo event listeners sui campi input
    scheduledMaintenanceAverageTimeInput.addEventListener("input", calculateScheduledMaintenancePieceIncidence)
    scheduledMaintenanceAverageTimeInput.addEventListener("change", calculateScheduledMaintenancePieceIncidence)
    scheduledMaintenanceAveragePeriodInput.addEventListener("input", calculateScheduledMaintenancePieceIncidence)
    scheduledMaintenanceAveragePeriodInput.addEventListener("change", calculateScheduledMaintenancePieceIncidence)

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateScheduledMaintenancePieceIncidence()

    console.log("Set up scheduled maintenance piece incidence automatic calculation")
  }

  private calculateScheduledMaintenancePieceIncidence(): void {
    const scheduledMaintenanceAverageTimeInput = document.querySelector(
      'input[name="scheduled_maintenance_average_time"]'
    ) as HTMLInputElement
    const scheduledMaintenanceAveragePeriodInput = document.querySelector(
      'input[name="scheduled_maintenance_average_period"]'
    ) as HTMLInputElement
    const scheduledMaintenancePieceIncidenceInput = document.querySelector(
      'input[name="scheduled_maintenance_piece_incidence"]'
    ) as HTMLInputElement

    if (!scheduledMaintenancePieceIncidenceInput) {
      console.log("Scheduled maintenance piece incidence input not found")
      return
    }

    const averageTime = parseFloat(scheduledMaintenanceAverageTimeInput?.value || "0") || 0
    const averagePeriod = parseFloat(scheduledMaintenanceAveragePeriodInput?.value || "1") || 1 // Default a 1 per evitare divisione per zero

    // Formula: scheduled_maintenance_average_time / scheduled_maintenance_average_period
    const pieceIncidence = averageTime / averagePeriod

    // Aggiorno il campo readonly del risultato
    scheduledMaintenancePieceIncidenceInput.value = pieceIncidence.toFixed(2)

    // console.log(
    //   `Calculated scheduled_maintenance_piece_incidence: ${pieceIncidence.toFixed(2)} (${averageTime} / ${averagePeriod})`
    // )

    // Dopo aver calcolato scheduled_maintenance_piece_incidence, calcolo anche tool_change_efficiency
    this.calculateToolChangeEfficiency()
    this.calculateOtherActivitiesEfficiency()
    this.calculateScheduledMaintenanceEfficiency()
    this.calculateMalfunctionsEfficiency()
  }

  private setupMalfunctionsPieceIncidenceCalculation(): void {
    // Setup calcoli automatici per malfunctions_piece_incidence
    const malfunctionsMtbfInput = document.querySelector('input[name="malfunctions_mtbf"]') as HTMLInputElement
    const malfunctionsMttrInput = document.querySelector('input[name="malfunctions_mttr"]') as HTMLInputElement
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement

    // Se non troviamo tutti i campi necessari, skippiamo
    if (!malfunctionsMtbfInput || !malfunctionsMttrInput) {
      console.log("Malfunctions inputs not found, skipping piece incidence calculation setup")
      return
    }

    // Funzione per calcolare malfunctions piece incidence
    const calculateMalfunctionsPieceIncidence = (): void => {
      this.calculateMalfunctionsPieceIncidence()
    }

    // Rimuovo eventuali listener precedenti (per evitare duplicati)
    malfunctionsMtbfInput.removeEventListener("input", calculateMalfunctionsPieceIncidence)
    malfunctionsMtbfInput.removeEventListener("change", calculateMalfunctionsPieceIncidence)
    malfunctionsMttrInput.removeEventListener("input", calculateMalfunctionsPieceIncidence)
    malfunctionsMttrInput.removeEventListener("change", calculateMalfunctionsPieceIncidence)

    // Aggiungo event listeners sui campi input
    malfunctionsMtbfInput.addEventListener("input", calculateMalfunctionsPieceIncidence)
    malfunctionsMtbfInput.addEventListener("change", calculateMalfunctionsPieceIncidence)
    malfunctionsMttrInput.addEventListener("input", calculateMalfunctionsPieceIncidence)
    malfunctionsMttrInput.addEventListener("change", calculateMalfunctionsPieceIncidence)

    // Aggiungo listener anche per equivalent_machine_time (se esiste)
    if (equivalentMachineTimeInput) {
      equivalentMachineTimeInput.removeEventListener("input", calculateMalfunctionsPieceIncidence)
      equivalentMachineTimeInput.removeEventListener("change", calculateMalfunctionsPieceIncidence)
      equivalentMachineTimeInput.addEventListener("input", calculateMalfunctionsPieceIncidence)
      equivalentMachineTimeInput.addEventListener("change", calculateMalfunctionsPieceIncidence)
    }

    // Calcolo iniziale con i valori precompilati (se presenti)
    calculateMalfunctionsPieceIncidence()

    console.log("Set up malfunctions piece incidence automatic calculation")
  }

  private calculateMalfunctionsPieceIncidence(): void {
    const malfunctionsMtbfInput = document.querySelector('input[name="malfunctions_mtbf"]') as HTMLInputElement
    const malfunctionsMttrInput = document.querySelector('input[name="malfunctions_mttr"]') as HTMLInputElement
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement
    const malfunctionsPieceIncidenceInput = document.querySelector(
      'input[name="malfunctions_piece_incidence"]'
    ) as HTMLInputElement

    if (!malfunctionsPieceIncidenceInput) {
      console.log("Malfunctions piece incidence input not found")
      return
    }

    const mtbf = parseFloat(malfunctionsMtbfInput?.value || "0") || 0
    const mttr = parseFloat(malfunctionsMttrInput?.value || "0") || 0
    const equivalentMachineTime = parseFloat(equivalentMachineTimeInput?.value || "0") || 0

    // Formula corretta: malfunctions_mttr/(malfunctions_mtbf/equivalent_machine_time)
    // Se MTBF = 0 o equivalentMachineTime = 0, imposto a 0 per evitare divisione per zero
    let pieceIncidence = 0
    if (mtbf > 0 && equivalentMachineTime > 0) {
      pieceIncidence = mttr / (mtbf / equivalentMachineTime)
    }

    // Aggiorno il campo readonly del risultato
    malfunctionsPieceIncidenceInput.value = pieceIncidence.toFixed(4)

    // console.log(
    //   `Calculated malfunctions_piece_incidence: ${pieceIncidence.toFixed(4)} (${mttr} / (${mtbf} / ${equivalentMachineTime}))`
    // )

    // Dopo aver calcolato malfunctions_piece_incidence, calcolo anche tool_change_efficiency
    this.calculateToolChangeEfficiency()
    this.calculateOtherActivitiesEfficiency()
    this.calculateScheduledMaintenanceEfficiency()
    this.calculateMalfunctionsEfficiency()
  }

  private setupOtherActivitiesEfficiencyCalculation(): void {
    // Setup calcoli automatici per other_activities_efficiency_percentage
    // Questo calcolo dipende da: equivalent_machine_time, cycle_operation_standstill,
    // e da tutti i piece_incidence (tool_change, other_activities, scheduled_maintenance, malfunctions)

    // Aggiungiamo listener solo per cycle_operation_standstill poiché gli altri campi
    // triggerano già il calcolo tramite le loro funzioni
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement

    if (cycleOperationStandstillInput) {
      // Funzione per calcolare other activities efficiency
      const calculateOtherActivitiesEfficiency = (): void => {
        this.calculateOtherActivitiesEfficiency()
      }

      // Rimuovo eventuali listener precedenti (per evitare duplicati)
      cycleOperationStandstillInput.removeEventListener("input", calculateOtherActivitiesEfficiency)
      cycleOperationStandstillInput.removeEventListener("change", calculateOtherActivitiesEfficiency)

      // Aggiungo event listeners
      cycleOperationStandstillInput.addEventListener("input", calculateOtherActivitiesEfficiency)
      cycleOperationStandstillInput.addEventListener("change", calculateOtherActivitiesEfficiency)
    }

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateOtherActivitiesEfficiency()

    console.log("Set up other activities efficiency automatic calculation")
  }

  private calculateOtherActivitiesEfficiency(): void {
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement
    const toolChangePieceIncidenceInput = document.querySelector(
      'input[name="tool_change_piece_incidence"]'
    ) as HTMLInputElement
    const otherActivitiesPieceIncidenceInput = document.querySelector(
      'input[name="other_activities_piece_incidence"]'
    ) as HTMLInputElement
    const scheduledMaintenancePieceIncidenceInput = document.querySelector(
      'input[name="scheduled_maintenance_piece_incidence"]'
    ) as HTMLInputElement
    const malfunctionsPieceIncidenceInput = document.querySelector(
      'input[name="malfunctions_piece_incidence"]'
    ) as HTMLInputElement
    const otherActivitiesEfficiencyInput = document.querySelector(
      'input[name="other_activities_efficiency_percentage"]'
    ) as HTMLInputElement

    if (!otherActivitiesEfficiencyInput) {
      console.log("Other activities efficiency input not found")
      return
    }

    const equivalentMachineTime = parseFloat(equivalentMachineTimeInput?.value || "0") || 0
    const cycleOperationStandstill = parseFloat(cycleOperationStandstillInput?.value || "0") || 0
    const toolChangePieceIncidence = parseFloat(toolChangePieceIncidenceInput?.value || "0") || 0
    const otherActivitiesPieceIncidence = parseFloat(otherActivitiesPieceIncidenceInput?.value || "0") || 0
    const scheduledMaintenancePieceIncidence = parseFloat(scheduledMaintenancePieceIncidenceInput?.value || "0") || 0
    const malfunctionsPieceIncidence = parseFloat(malfunctionsPieceIncidenceInput?.value || "0") || 0

    // Formula: other_activities_piece_incidence / (equivalent_machine_time + cycle_operation_standstill + tool_change_piece_incidence + other_activities_piece_incidence + scheduled_maintenance_piece_incidence + malfunctions_piece_incidence)
    const denominator =
      equivalentMachineTime +
      cycleOperationStandstill +
      toolChangePieceIncidence +
      otherActivitiesPieceIncidence +
      scheduledMaintenancePieceIncidence +
      malfunctionsPieceIncidence

    // Se il denominatore è 0, imposto efficiency a 0 per evitare divisione per zero
    const efficiency = denominator > 0 ? (otherActivitiesPieceIncidence / denominator) * 100 : 0

    // Aggiorno il campo readonly del risultato
    otherActivitiesEfficiencyInput.value = efficiency.toFixed(2)

    // console.log(
    //   `Calculated other_activities_efficiency_percentage: ${efficiency.toFixed(2)}% (${otherActivitiesPieceIncidence} / ${denominator})`
    // )

    // Dopo aver calcolato other_activities_efficiency, ricalcolo anche technical_efficiency
    this.calculateTechnicalEfficiency()
  }

  private setupScheduledMaintenanceEfficiencyCalculation(): void {
    // Setup calcoli automatici per scheduled_maintenance_efficiency_percentage
    // Questo calcolo dipende da: equivalent_machine_time, cycle_operation_standstill,
    // e da tutti i piece_incidence (tool_change, other_activities, scheduled_maintenance, malfunctions)

    // Aggiungiamo listener solo per cycle_operation_standstill poiché gli altri campi
    // triggerano già il calcolo tramite le loro funzioni
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement

    if (cycleOperationStandstillInput) {
      // Funzione per calcolare scheduled maintenance efficiency
      const calculateScheduledMaintenanceEfficiency = (): void => {
        this.calculateScheduledMaintenanceEfficiency()
      }

      // Rimuovo eventuali listener precedenti (per evitare duplicati)
      cycleOperationStandstillInput.removeEventListener("input", calculateScheduledMaintenanceEfficiency)
      cycleOperationStandstillInput.removeEventListener("change", calculateScheduledMaintenanceEfficiency)

      // Aggiungo event listeners
      cycleOperationStandstillInput.addEventListener("input", calculateScheduledMaintenanceEfficiency)
      cycleOperationStandstillInput.addEventListener("change", calculateScheduledMaintenanceEfficiency)
    }

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateScheduledMaintenanceEfficiency()

    console.log("Set up scheduled maintenance efficiency automatic calculation")
  }

  private calculateScheduledMaintenanceEfficiency(): void {
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement
    const toolChangePieceIncidenceInput = document.querySelector(
      'input[name="tool_change_piece_incidence"]'
    ) as HTMLInputElement
    const otherActivitiesPieceIncidenceInput = document.querySelector(
      'input[name="other_activities_piece_incidence"]'
    ) as HTMLInputElement
    const scheduledMaintenancePieceIncidenceInput = document.querySelector(
      'input[name="scheduled_maintenance_piece_incidence"]'
    ) as HTMLInputElement
    const malfunctionsPieceIncidenceInput = document.querySelector(
      'input[name="malfunctions_piece_incidence"]'
    ) as HTMLInputElement
    const scheduledMaintenanceEfficiencyInput = document.querySelector(
      'input[name="scheduled_maintenance_efficiency_percentage"]'
    ) as HTMLInputElement

    if (!scheduledMaintenanceEfficiencyInput) {
      console.log("Scheduled maintenance efficiency input not found")
      return
    }

    const equivalentMachineTime = parseFloat(equivalentMachineTimeInput?.value || "0") || 0
    const cycleOperationStandstill = parseFloat(cycleOperationStandstillInput?.value || "0") || 0
    const toolChangePieceIncidence = parseFloat(toolChangePieceIncidenceInput?.value || "0") || 0
    const otherActivitiesPieceIncidence = parseFloat(otherActivitiesPieceIncidenceInput?.value || "0") || 0
    const scheduledMaintenancePieceIncidence = parseFloat(scheduledMaintenancePieceIncidenceInput?.value || "0") || 0
    const malfunctionsPieceIncidence = parseFloat(malfunctionsPieceIncidenceInput?.value || "0") || 0

    // Formula: scheduled_maintenance_piece_incidence / (equivalent_machine_time + cycle_operation_standstill + tool_change_piece_incidence + other_activities_piece_incidence + scheduled_maintenance_piece_incidence + malfunctions_piece_incidence)
    const denominator =
      equivalentMachineTime +
      cycleOperationStandstill +
      toolChangePieceIncidence +
      otherActivitiesPieceIncidence +
      scheduledMaintenancePieceIncidence +
      malfunctionsPieceIncidence

    // Se il denominatore è 0, imposto efficiency a 0 per evitare divisione per zero
    const efficiency = denominator > 0 ? (scheduledMaintenancePieceIncidence / denominator) * 100 : 0

    // Aggiorno il campo readonly del risultato
    scheduledMaintenanceEfficiencyInput.value = efficiency.toFixed(2)

    // console.log(
    //   `Calculated scheduled_maintenance_efficiency_percentage: ${efficiency.toFixed(2)}% (${scheduledMaintenancePieceIncidence} / ${denominator})`
    // )

    // Dopo aver calcolato scheduled_maintenance_efficiency, ricalcolo anche technical_efficiency
    this.calculateTechnicalEfficiency()
  }

  private setupMalfunctionsEfficiencyCalculation(): void {
    // Setup calcoli automatici per malfunctions_efficiency_percentage
    // Questo calcolo dipende da: equivalent_machine_time, cycle_operation_standstill,
    // e da tutti i piece_incidence (tool_change, other_activities, scheduled_maintenance, malfunctions)

    // Aggiungiamo listener solo per cycle_operation_standstill poiché gli altri campi
    // triggerano già il calcolo tramite le loro funzioni
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement

    if (cycleOperationStandstillInput) {
      // Funzione per calcolare malfunctions efficiency
      const calculateMalfunctionsEfficiency = (): void => {
        this.calculateMalfunctionsEfficiency()
      }

      // Rimuovo eventuali listener precedenti (per evitare duplicati)
      cycleOperationStandstillInput.removeEventListener("input", calculateMalfunctionsEfficiency)
      cycleOperationStandstillInput.removeEventListener("change", calculateMalfunctionsEfficiency)

      // Aggiungo event listeners
      cycleOperationStandstillInput.addEventListener("input", calculateMalfunctionsEfficiency)
      cycleOperationStandstillInput.addEventListener("change", calculateMalfunctionsEfficiency)
    }

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateMalfunctionsEfficiency()

    console.log("Set up malfunctions efficiency automatic calculation")
  }

  private calculateMalfunctionsEfficiency(): void {
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement
    const toolChangePieceIncidenceInput = document.querySelector(
      'input[name="tool_change_piece_incidence"]'
    ) as HTMLInputElement
    const otherActivitiesPieceIncidenceInput = document.querySelector(
      'input[name="other_activities_piece_incidence"]'
    ) as HTMLInputElement
    const scheduledMaintenancePieceIncidenceInput = document.querySelector(
      'input[name="scheduled_maintenance_piece_incidence"]'
    ) as HTMLInputElement
    const malfunctionsPieceIncidenceInput = document.querySelector(
      'input[name="malfunctions_piece_incidence"]'
    ) as HTMLInputElement
    const malfunctionsEfficiencyInput = document.querySelector(
      'input[name="malfunctions_efficiency_percentage"]'
    ) as HTMLInputElement

    if (!malfunctionsEfficiencyInput) {
      console.log("Malfunctions efficiency input not found")
      return
    }

    const equivalentMachineTime = parseFloat(equivalentMachineTimeInput?.value || "0") || 0
    const cycleOperationStandstill = parseFloat(cycleOperationStandstillInput?.value || "0") || 0
    const toolChangePieceIncidence = parseFloat(toolChangePieceIncidenceInput?.value || "0") || 0
    const otherActivitiesPieceIncidence = parseFloat(otherActivitiesPieceIncidenceInput?.value || "0") || 0
    const scheduledMaintenancePieceIncidence = parseFloat(scheduledMaintenancePieceIncidenceInput?.value || "0") || 0
    const malfunctionsPieceIncidence = parseFloat(malfunctionsPieceIncidenceInput?.value || "0") || 0

    // Formula: malfunctions_piece_incidence / (equivalent_machine_time + cycle_operation_standstill + tool_change_piece_incidence + other_activities_piece_incidence + scheduled_maintenance_piece_incidence + malfunctions_piece_incidence)
    const denominator =
      equivalentMachineTime +
      cycleOperationStandstill +
      toolChangePieceIncidence +
      otherActivitiesPieceIncidence +
      scheduledMaintenancePieceIncidence +
      malfunctionsPieceIncidence

    // Se il denominatore è 0, imposto efficiency a 0 per evitare divisione per zero
    const efficiency = denominator > 0 ? (malfunctionsPieceIncidence / denominator) * 100 : 0

    // Aggiorno il campo readonly del risultato
    malfunctionsEfficiencyInput.value = efficiency.toFixed(2)

    // console.log(
    //   `Calculated malfunctions_efficiency_percentage: ${efficiency.toFixed(2)}% (${malfunctionsPieceIncidence} / ${denominator})`
    // )

    // Dopo aver calcolato malfunctions_efficiency, ricalcolo anche technical_efficiency
    this.calculateTechnicalEfficiency()
  }

  private setupTechnicalEfficiencyCalculation(): void {
    // Setup calcoli automatici per technical_efficiency
    // Questo calcolo dipende da tutte le efficiency percentages:
    // tool_change_efficiency_percentage, other_activities_efficiency_percentage,
    // scheduled_maintenance_efficiency_percentage, malfunctions_efficiency_percentage

    // Non aggiungiamo listener qui perché il calcolo viene triggerato
    // dalle funzioni che calcolano le singole efficiency percentages

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateTechnicalEfficiency()

    console.log("Set up technical efficiency automatic calculation")
  }

  private calculateTechnicalEfficiency(): void {
    const toolChangeEfficiencyInput = document.querySelector(
      'input[name="tool_change_efficiency_percentage"]'
    ) as HTMLInputElement
    const otherActivitiesEfficiencyInput = document.querySelector(
      'input[name="other_activities_efficiency_percentage"]'
    ) as HTMLInputElement
    const scheduledMaintenanceEfficiencyInput = document.querySelector(
      'input[name="scheduled_maintenance_efficiency_percentage"]'
    ) as HTMLInputElement
    const malfunctionsEfficiencyInput = document.querySelector(
      'input[name="malfunctions_efficiency_percentage"]'
    ) as HTMLInputElement
    const technicalEfficiencyInput = document.querySelector('input[name="technical_efficiency"]') as HTMLInputElement

    if (!technicalEfficiencyInput) {
      console.log("Technical efficiency input not found")
      return
    }

    const toolChangeEfficiency = parseFloat(toolChangeEfficiencyInput?.value || "0") || 0
    const otherActivitiesEfficiency = parseFloat(otherActivitiesEfficiencyInput?.value || "0") || 0
    const scheduledMaintenanceEfficiency = parseFloat(scheduledMaintenanceEfficiencyInput?.value || "0") || 0
    const malfunctionsEfficiency = parseFloat(malfunctionsEfficiencyInput?.value || "0") || 0

    // Formula: 100 - (tool_change_efficiency_percentage + other_activities_efficiency_percentage + scheduled_maintenance_efficiency_percentage + malfunctions_efficiency_percentage)
    const totalLosses =
      toolChangeEfficiency + otherActivitiesEfficiency + scheduledMaintenanceEfficiency + malfunctionsEfficiency
    const technicalEfficiency = 100 - totalLosses

    // Aggiorno il campo readonly del risultato
    technicalEfficiencyInput.value = technicalEfficiency.toFixed(2)

    // console.log(`Calculated technical_efficiency: ${technicalEfficiency.toFixed(2)}% (100 - ${totalLosses.toFixed(2)})`)

    // Dopo aver calcolato technical_efficiency, ricalcolo anche final hourly output
    this.calculateFinalHourlyOutput()
  }

  private setupFinalHourlyOutputCalculation(): void {
    // Setup calcoli automatici per hourly_output finale
    // Questo calcolo dipende da: machine_time_cycle_operation_hourly_output e technical_efficiency

    // Non aggiungiamo listener qui perché il calcolo viene triggerato
    // dalle funzioni che calcolano machine_time_cycle_operation_hourly_output e technical_efficiency

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateFinalHourlyOutput()

    console.log("Set up final hourly output automatic calculation")
  }

  private calculateFinalHourlyOutput(): void {
    const machineTimeHourlyOutputInput = document.querySelector(
      'input[name="machine_time_cycle_operation_hourly_output"]'
    ) as HTMLInputElement
    const technicalEfficiencyInput = document.querySelector('input[name="technical_efficiency"]') as HTMLInputElement
    const finalHourlyOutputInput = document.querySelector('input[name="hourly_output"]') as HTMLInputElement

    if (!finalHourlyOutputInput) {
      console.log("Final hourly output input not found")
      return
    }

    const machineTimeHourlyOutput = parseFloat(machineTimeHourlyOutputInput?.value || "0") || 0
    const technicalEfficiency = parseFloat(technicalEfficiencyInput?.value || "0") || 0

    // Formula: (machine_time_cycle_operation_hourly_output * technical_efficiency) / 100
    const finalHourlyOutput = (machineTimeHourlyOutput * technicalEfficiency) / 100

    // Aggiorno il campo readonly del risultato
    finalHourlyOutputInput.value = finalHourlyOutput.toFixed(2)

    // console.log(
    //   `Calculated hourly_output: ${finalHourlyOutput.toFixed(2)} pcs/h (${machineTimeHourlyOutput} * ${technicalEfficiency}% / 100)`
    // )
  }

  private setupToolChangeEfficiencyCalculation(): void {
    // Setup calcoli automatici per tool_change_efficiency_percentage
    // Questo calcolo dipende da: equivalent_machine_time, cycle_operation_standstill,
    // e da tutti e tre i piece_incidence

    // Aggiungiamo listener solo per cycle_operation_standstill poiché gli altri campi
    // triggerano già il calcolo tramite le loro funzioni
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement

    if (cycleOperationStandstillInput) {
      // Funzione per calcolare tool change efficiency
      const calculateToolChangeEfficiency = (): void => {
        this.calculateToolChangeEfficiency()
        this.calculateOtherActivitiesEfficiency()
      }

      // Rimuovo eventuali listener precedenti (per evitare duplicati)
      cycleOperationStandstillInput.removeEventListener("input", calculateToolChangeEfficiency)
      cycleOperationStandstillInput.removeEventListener("change", calculateToolChangeEfficiency)

      // Aggiungo event listeners
      cycleOperationStandstillInput.addEventListener("input", calculateToolChangeEfficiency)
      cycleOperationStandstillInput.addEventListener("change", calculateToolChangeEfficiency)
    }

    // Calcolo iniziale con i valori precompilati (se presenti)
    this.calculateToolChangeEfficiency()
    this.calculateOtherActivitiesEfficiency()

    console.log("Set up tool change efficiency automatic calculation")
  }

  private calculateToolChangeEfficiency(): void {
    const equivalentMachineTimeInput = document.querySelector(
      'input[name="equivalent_machine_time"]'
    ) as HTMLInputElement
    const cycleOperationStandstillInput = document.querySelector(
      'input[name="cycle_operation_standstill"]'
    ) as HTMLInputElement
    const toolChangePieceIncidenceInput = document.querySelector(
      'input[name="tool_change_piece_incidence"]'
    ) as HTMLInputElement
    const otherActivitiesPieceIncidenceInput = document.querySelector(
      'input[name="other_activities_piece_incidence"]'
    ) as HTMLInputElement
    const scheduledMaintenancePieceIncidenceInput = document.querySelector(
      'input[name="scheduled_maintenance_piece_incidence"]'
    ) as HTMLInputElement
    const malfunctionsPieceIncidenceInput = document.querySelector(
      'input[name="malfunctions_piece_incidence"]'
    ) as HTMLInputElement
    const toolChangeEfficiencyInput = document.querySelector(
      'input[name="tool_change_efficiency_percentage"]'
    ) as HTMLInputElement

    if (!toolChangeEfficiencyInput) {
      console.log("Tool change efficiency input not found")
      return
    }

    const equivalentMachineTime = parseFloat(equivalentMachineTimeInput?.value || "0") || 0
    const cycleOperationStandstill = parseFloat(cycleOperationStandstillInput?.value || "0") || 0
    const toolChangePieceIncidence = parseFloat(toolChangePieceIncidenceInput?.value || "0") || 0
    const otherActivitiesPieceIncidence = parseFloat(otherActivitiesPieceIncidenceInput?.value || "0") || 0
    const scheduledMaintenancePieceIncidence = parseFloat(scheduledMaintenancePieceIncidenceInput?.value || "0") || 0
    const malfunctionsPieceIncidence = parseFloat(malfunctionsPieceIncidenceInput?.value || "0") || 0

    // Formula: tool_change_piece_incidence / (equivalent_machine_time + cycle_operation_standstill + tool_change_piece_incidence + other_activities_piece_incidence + scheduled_maintenance_piece_incidence + malfunctions_piece_incidence)
    const denominator =
      equivalentMachineTime +
      cycleOperationStandstill +
      toolChangePieceIncidence +
      otherActivitiesPieceIncidence +
      scheduledMaintenancePieceIncidence +
      malfunctionsPieceIncidence

    // Se il denominatore è 0, imposto efficiency a 0 per evitare divisione per zero
    const efficiency = denominator > 0 ? (toolChangePieceIncidence / denominator) * 100 : 0

    // Aggiorno il campo readonly del risultato
    toolChangeEfficiencyInput.value = efficiency.toFixed(2)

    // console.log(
    //   `Calculated tool_change_efficiency_percentage: ${efficiency.toFixed(2)}% (${toolChangePieceIncidence} / ${denominator}) - includes malfunctions_piece_incidence: ${malfunctionsPieceIncidence}`
    // )

    // Dopo aver calcolato tool_change_efficiency, ricalcolo anche technical_efficiency
    this.calculateTechnicalEfficiency()
  }

  private setupStep6RequestHandlers(): void {
    // Gestisco il pulsante per aggiungere una nuova richiesta
    const addRequestBtn = document.getElementById("add-request-btn")

    if (addRequestBtn) {
      // Rimuovo eventuali listener precedenti per evitare duplicati
      const newAddRequestBtn = addRequestBtn.cloneNode(true) as HTMLElement
      addRequestBtn.parentNode?.replaceChild(newAddRequestBtn, addRequestBtn)

      // Aggiungo il nuovo event listener
      newAddRequestBtn.addEventListener("click", e => {
        e.preventDefault()
        this.addNewRequest()
      })

      console.log("Set up add request button handler")
    }

    // Gestisco i pulsanti per rimuovere le richieste (delegated event listener)
    // Questo è già gestito globalmente e non ha bisogno di essere ricreato
    console.log("Set up Step 6 request handlers")
  }

  private setupGlobalStep6RemoveHandlers(): void {
    // Gestisco i pulsanti per rimuovere le richieste (delegated event listener globale)
    document.addEventListener("click", e => {
      const target = e.target as HTMLElement

      if (target.classList.contains("remove-request-btn") || target.closest(".remove-request-btn")) {
        e.preventDefault()
        const removeBtn = target.classList.contains("remove-request-btn")
          ? target
          : target.closest(".remove-request-btn")
        const index = removeBtn?.getAttribute("data-index")

        if (index) {
          this.removeRequest(parseInt(index))
        }
      }
    })

    console.log("Set up global Step 6 remove handlers")
  }

  private addNewRequest(): void {
    const container = document.getElementById("deviation-requests-container")

    if (!container) {
      console.error("Deviation requests container not found")
      return
    }

    const existingItems = container.querySelectorAll(".deviation-request-item")
    const newIndex = existingItems ? existingItems.length : 0
    console.log(`Current number of request items: ${newIndex}`)
    const newRequestHtml = `
      <div class="deviation-request-item" data-index="${newIndex}">
        <div class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Deviation Request #${newIndex + 1}</h5>
            <button type="button" class="btn btn-sm btn-link remove-request-btn" data-index="${newIndex}" title="Remove this request">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div class="card-body">
            <!-- Reason section -->
            <div class="form-row">
              <div class="row">
                <div class="col-md-6">
                  <label class="control-label">Select Type of Reason:</label>
                  <select class="form-control" name="requests[${newIndex}][reason_type]">
                    <option value="">Select...</option>
                    <option value="technical">Technical</option>
                    <option value="timing">Timing</option>
                    <option value="cost">Cost</option>
                    <option value="others">Others</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Explanation and Comment section -->
            <div class="form-group">
              <label class="control-label">Request (Technical description):</label>
              <textarea class="form-control" name="requests[${newIndex}][request]" placeholder="Enter request" rows="4"></textarea>
            </div>
            <!-- <div class="form-group">
              <label class="control-label">IVG Comment:</label>
              <textarea class="form-control" name="requests[${newIndex}][comment]" placeholder="Enter comment" rows="4"></textarea>
            </div> -->
          </div>
        </div>
      </div>
    `

    container.insertAdjacentHTML("beforeend", newRequestHtml)

    console.log(`Added new request item with index ${newIndex}`)
  }

  private removeRequest(index: number): void {
    const requestItem = document.querySelector(`.deviation-request-item[data-index="${index}"]`)

    if (requestItem) {
      requestItem.remove()
      this.reindexRequestItems()
      console.log(`Removed request item with index ${index}`)
    }
  }

  private reindexRequestItems(): void {
    const requestItems = document.querySelectorAll(".deviation-request-item")

    requestItems.forEach((item, newIndex) => {
      // Aggiorno l'attributo data-index
      item.setAttribute("data-index", newIndex.toString())

      // Aggiorno il titolo
      const title = item.querySelector(".card-header h5")
      if (title) {
        title.textContent = `Deviation Request #${newIndex + 1}`
      }

      // Aggiorno i nomi dei campi input
      const reasonSelect = item.querySelector('select[name*="reason_type"]') as HTMLSelectElement
      const requestTextarea = item.querySelector('textarea[name*="request"]') as HTMLTextAreaElement
      const commentTextarea = item.querySelector('textarea[name*="comment"]') as HTMLTextAreaElement
      const removeBtn = item.querySelector(".remove-request-btn")

      if (reasonSelect) {
        reasonSelect.name = `requests[${newIndex}][reason_type]`
      }

      if (requestTextarea) {
        requestTextarea.name = `requests[${newIndex}][request]`
      }

      if (commentTextarea) {
        commentTextarea.name = `requests[${newIndex}][comment]`
      }

      if (removeBtn) {
        removeBtn.setAttribute("data-index", newIndex.toString())
        // Nascondo il pulsante remove per il primo item (index 0)
        // if (newIndex === 0) {
        //   ;(removeBtn as HTMLElement).style.display = "none"
        // } else {
        //   ;(removeBtn as HTMLElement).style.display = "block"
        // }
      }
    })

    console.log(`Reindexed ${requestItems.length} request items`)
  }

  private switchToForm(formNumber: string): void {
    console.log(`Switching to form ${formNumber}`)

    // Rimuovo active da tutti i link
    const allLinks = document.querySelectorAll(".list-group-item")
    allLinks.forEach(link => link.classList.remove("active"))

    // Nascondo tutti i form parts
    const allFormParts = document.querySelectorAll(".form-part")
    allFormParts.forEach(part => {
      ;(part as HTMLElement).style.display = "none"
      part.classList.remove("active")
    })

    // Attivo il link selezionato
    const activeLink = document.querySelector(`[data-form="${formNumber}"]`)
    if (activeLink) {
      activeLink.classList.add("active")
    }

    // Mostro il form part selezionato
    const targetFormPart = document.getElementById(`form-part-${formNumber}`)
    if (targetFormPart) {
      targetFormPart.style.display = "block"
      targetFormPart.classList.add("active")

      // Smooth scroll verso il form
      targetFormPart.scrollIntoView({
        behavior: "smooth",
        block: "start"
      })
    }

    // Aggiorno lo stato corrente
    this.currentActiveForm = formNumber

    // Reinizializzo i handler per Step 6 se necessario
    if (formNumber === "6") {
      // Piccolo delay per assicurarsi che il DOM sia aggiornato
      setTimeout(() => {
        this.setupStep6RequestHandlers()
      }, 100)
    }

    // Reinizializzo i calcoli per Step 7 se necessario
    if (formNumber === "7") {
      // Piccolo delay per assicurarsi che il DOM sia aggiornato
      setTimeout(() => {
        this.setupStep7Calculations()
      }, 100)
    }

    // Aggiorno la progress bar
    this.updateProgressBar()
  }

  private updateProgressBar(): void {
    const progressBar = document.querySelector(".progress-bar") as HTMLElement
    const progressText = document.querySelector(".progress-wrapper small") as HTMLElement

    if (progressBar && progressText) {
      // Conto quanti step sono stati completati
      const completedLinks = document.querySelectorAll(".list-group-item.completed")
      const completedCount = completedLinks.length

      const progressPercentage = (completedCount / this.total_steps) * 100

      progressBar.style.width = `${progressPercentage}%`
      progressBar.setAttribute("aria-valuenow", progressPercentage.toString())
      progressText.textContent = `${completedCount} of ${this.total_steps} completed`
    }
  }

  private async handleFormSave(form: HTMLFormElement, stepNumber: string): Promise<void> {
    console.log(`Handling form save for step ${stepNumber}`)
    const formPart = document.getElementById(`form-part-${stepNumber}`)
    if (!formPart) {
      console.error(`Step ${stepNumber} not found in the form`)
      return
    }

    const stepKey = formPart.getAttribute("data-step-key")

    if (!stepKey) {
      console.error(`Step key not found for step ${stepNumber}`)
      return
    }

    this.currentStepKey = stepKey

    // Validazione specifica per step - controllo checkbox documentazione
    if (stepKey === "documentation") {
      const checkbox = document.getElementById("documentationViewedCheck") as HTMLInputElement
      if (!checkbox || !checkbox.checked) {
        this.showAlert(
          "error",
          "Attention: You must download the technical documentation and confirm that you have reviewed it by checking the confirmation checkbox before proceeding to the next step."
        )
        return
      }
    }

    // Validazione specifica per step - controllo selezione documenti
    if (stepKey === "specification_list") {
      const selectedCheckboxes = document.querySelectorAll('input[name="selected_documents[]"]:checked')
      if (selectedCheckboxes.length === 0) {
        this.showAlert(
          "error",
          "Attention: You must select at least one document from the specification list before proceeding to the next step."
        )

        // Mostro anche l'alert locale del form
        const localAlert = document.getElementById("documentSelectionAlert")
        if (localAlert) {
          localAlert.style.display = "block"
        }
        return
      }
    }

    // Raccolgo i dati del form
    const formData = this.collectFormData(form, stepNumber)

    // Log dei dati raccolti
    console.log("Form data collected:", formData)

    // Mostro loading sul bottone
    const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement
    const originalText = submitButton.innerHTML
    this.showButtonLoading(submitButton)

    try {
      // Salvo i dati usando axios
      const response = await this.saveStepData(stepNumber, formData)

      console.log("Step saved successfully:", response)
      this.showAlert("success", `Step ${stepNumber} saved successfully!`)

      // Avanzo al prossimo step se non è l'ultimo
      this.handleStepCompletion(stepNumber)
    } catch (error: any) {
      console.error("Error saving step:", error)

      // Gestisco diversi tipi di errore
      let errorMessage = `Error saving step ${stepNumber}. Please try again.`

      // Se è un errore di validazione, mostro i dettagli
      if (error.message && error.message.includes("Please complete all required fields")) {
        errorMessage = error.message.replace(/\n/g, "<br>")
      }

      this.showAlert("error", errorMessage)
    } finally {
      // Ripristino il bottone
      this.restoreButton(submitButton, originalText)
    }
  }

  private collectFormData(form: HTMLFormElement, stepNumber: string): { [key: string]: any } {
    const formData = new FormData(form)
    const now = new Date()
    const formattedDate = now.toISOString().slice(0, 19).replace("T", " ")

    // Struttura JSON secondo il nuovo formato richiesto
    const stepKey = `${this.currentStepKey}`
    const data: { [key: string]: any } = {
      [this.currentStepKey]: {
        completed: true,
        completed_at: formattedDate,
        data: {}
      }
    }

    // Gestione speciale per step 1 - General information
    if (this.currentStepKey === "general_info") {
      const generalInfoData = this.collectStepGeneralInfo()
      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...generalInfoData }
      }

      return data
    }

    if (this.currentStepKey === "plant_utilities") {
      const plantUtilitiesData = this.collectStepPlantUtilitiesData()
      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...plantUtilitiesData }
      }

      return data
    }

    if (this.currentStepKey === "documentation") {
      formData.forEach((value, key) => {
        data[this.currentStepKey].data[key] = value
      })
      return data
    }

    // Gestione speciale per step selezione documenti
    if (this.currentStepKey === "specification_list") {
      type SpecificationDocument = {
        id: string
        code: string
        description: string
        class_description: string
        version: string
      }

      const documentCheckboxes = document.querySelectorAll('input[name="selected_documents[]"]')

      // Salvo l'intero elenco proposto al fornitore, con il flag di selezione: il PDF deve poter
      // riportare anche i documenti non selezionati senza interrogare il database.
      const availableDocuments: Array<SpecificationDocument & { selected: boolean }> = []
      const selectedDocuments: Array<SpecificationDocument> = []

      documentCheckboxes.forEach(checkbox => {
        const input = checkbox as HTMLInputElement
        const documentData: SpecificationDocument = {
          id: input.value,
          code: input.getAttribute("data-code") || "",
          description: input.getAttribute("data-description") || "",
          class_description: input.getAttribute("data-class-description") || "",
          version: input.getAttribute("data-version") || ""
        }

        availableDocuments.push({ ...documentData, selected: input.checked })

        if (input.checked) {
          selectedDocuments.push(documentData)
        }
      })

      data[this.currentStepKey].data["available_documents"] = availableDocuments
      data[this.currentStepKey].data["selected_documents"] = selectedDocuments

      return data
    }

    // Gestione speciale per step Safety and Ergonomics Conformity
    if (this.currentStepKey === "safety_ergonomics") {
      const stepData = this.collectStepSafetyErgonomics()
      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    // Gestione speciale per Components
    if (this.currentStepKey === "components") {
      const stepData = this.$collectStepComponents()

      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    // Gestione speciale per step - Deviation Request
    if (this.currentStepKey === "deviation_request") {
      const stepData = this.$collectStepDeviationRequest()

      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    // Gestione speciale per step - Technical efficiency
    if (this.currentStepKey === "technical_efficiency") {
      const stepData = this.collectStepTechicalEfficiency()

      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    // Gestione speciale per step 8 - Running Costs
    if (this.currentStepKey === "running_costs") {
      const stepData = this.$collectStepRunningCosts()

      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    // Gestione speciale per step - Energy Assessment
    if (this.currentStepKey === "energy_assessment") {
      const stepData = this.$collectStepEnergyAssesment()

      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    // Gestione speciale per step 10 - Maintenance Time
    if (this.currentStepKey === "maintenance_time") {
      const stepData = this.$collectStepMaintenanceTime()

      data[this.currentStepKey] = {
        completed: true,
        completed_at: formattedDate,
        data: { ...stepData }
      }

      return data
    }

    return data
  }

  private getProjectId(): string {
    // Recupero l'ID del progetto dal container principale
    const container = document.getElementById("fpi-mem028-container")
    if (!container) {
      console.error("FpiMemO28 container not found")
      return ""
    }

    const projectId = container.getAttribute("data-project-id")
    if (!projectId) {
      console.error("Project ID not found in container")
      return ""
    }

    return projectId
  }

  private async saveStepData(stepNumber: string, stepData: { [key: string]: any }): Promise<any> {
    try {
      console.log("Saving step data to server:", stepData)

      const response = await axios.post(
        `${CI.base_url}front/fpi_mem028/save_step`,
        {
          project_id: this.getProjectId(),
          total_steps: this.total_steps,
          step: stepNumber,
          stepData,
          form_id: this.formId
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        }
      )

      const result = response.data

      if (!result.success) {
        // Se è un errore di validazione, preservo il messaggio dettagliato
        const errorMessage = result.message || "Save failed"
        const error: any = new Error(errorMessage)

        // Aggiungo informazioni aggiuntive se disponibili
        if (result.type === "validation_error") {
          error.type = "validation_error"
          error.step = result.step
        }

        throw error
      }

      console.log("Step saved successfully:", result)

      // Aggiorno il form_id dopo la prima creazione
      if (result.form_id && !this.formId) {
        const newFormId = result.form_id.toString()
        this.formId = newFormId
        const container = document.getElementById("fpi-mem028-container")
        container?.setAttribute("data-form-id", newFormId)
      }

      return result
    } catch (error: any) {
      console.error("Network error saving step:", error)

      // Gestisco diversi tipi di errore
      if (axios.isAxiosError(error)) {
        if (error.response) {
          // Il server ha risposto con un codice di stato di errore
          throw new Error(`Server error: ${error.response.status} - ${error.response.data?.message || "Unknown error"}`)
        } else if (error.request) {
          // La richiesta è stata fatta ma non è arrivata risposta
          throw new Error("Network error: Unable to reach server")
        }
      }

      // Altri tipi di errore
      throw error
    }
  }

  private showButtonLoading(button: HTMLButtonElement): void {
    button.disabled = true
    button.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Saving...'
  }

  private restoreButton(button: HTMLButtonElement, originalText: string): void {
    button.disabled = false
    button.innerHTML = originalText
  }

  private handleStepCompletion(stepNumber: string): void {
    const currentStepNum = parseInt(stepNumber)
    const nextStepNum = currentStepNum + 1

    if (nextStepNum <= this.total_steps) {
      console.log(`Moving to next step: ${nextStepNum}`)

      // Aggiorno visualmente lo stato dei link
      this.updateNavigationState(currentStepNum, nextStepNum)

      // Passo al prossimo step
      setTimeout(() => {
        this.switchToForm(nextStepNum.toString())
      }, 1500) // Delay per permettere all'utente di vedere il messaggio di successo
    } else {
      console.log("All steps completed!")
      this.showAlert("success", "All steps completed! Form is ready for final submission.")

      // Redirect after 3000 ms to allow user to read the message
      setTimeout(() => {
        window.location.href = `${this.getBaseUrl()}/front/documents/${this.getProjectId()}`
      }, 3000)
    }
  }

  private updateNavigationState(completedStep: number, nextStep: number): void {
    // Aggiorno lo stato dei link nella navigazione
    const completedLink = document.querySelector(`[data-form="${completedStep.toString()}"]`)
    const nextLink = document.querySelector(`[data-form="${nextStep.toString()}"]`)

    if (completedLink) {
      completedLink.classList.remove("active")
      // Aggiungo una classe 'completed' per styling specifico
      completedLink.classList.add("completed")
    }

    if (nextLink) {
      nextLink.classList.remove("disabled")
    }

    // Aggiorno la progress bar dopo aver marcato lo step come completato
    this.updateProgressBar()
  }

  private showAlert(type: "success" | "error", message: string): void {
    const alertContainer = document.getElementById("alert") || document.querySelector(".content")
    if (!alertContainer) return

    // Converto i \n in <br> per le interruzioni di riga negli alert HTML
    const formattedMessage = message.replace(/\n/g, "<br>")

    const alert = document.createElement("div")
    alert.className = `alert alert-${type === "success" ? "success" : "danger"} alert-dismissible fade in`
    alert.innerHTML = `
      <button type="button" class="close" data-dismiss="alert">
        <span>&times;</span>
      </button>
      <i class="fa fa-${type === "success" ? "check" : "exclamation-triangle"}"></i>
      ${formattedMessage}
    `

    // Inserisci in cima al container
    alertContainer.insertBefore(alert, alertContainer.firstChild)

    // Auto-hide after 5 seconds
    if (type === "success") {
      setTimeout(() => {
        alert.remove()
      }, 3000)
    }

    // Scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  private initializeComponents(): void {
    console.log("Initializing FpiMemO28 components")

    // Trova il form part attualmente attivo dal server (basato su current_step)
    const activeFormPart = document.querySelector(".form-part.active") as HTMLElement
    if (activeFormPart) {
      const activeFormId = activeFormPart.id
      const formNumber = activeFormId.replace("form-part-", "")
      this.currentActiveForm = formNumber
      this.updateProgressBar()
    } else {
      // Fallback al primo form se nessuno è attivo
      this.switchToForm("1")
    }
  }

  /**
   * Raccolta dati specifici per Step 1 - Deviation Request
   */
  private collectStepGeneralInfo(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}
    console.log("Collecting General Info form data...")
    // Raccolta dei campi required
    const supplierNameInput = document.querySelector(`input[name="name"]`) as HTMLInputElement
    const supplierDateInput = document.querySelector(`input[name="date"]`) as HTMLInputElement
    const supplierLegalRepresentativeInput = document.querySelector(
      `input[name="legal_rappresentative_name"]`
    ) as HTMLInputElement
    const supplierLegalRepresentativeSignatureInput = document.querySelector(
      `input[name="legal_rappresentative_signature"]`
    ) as HTMLInputElement
    const supplierPositionWithinCompanyInput = document.querySelector(
      `input[name="position_within_company"]`
    ) as HTMLInputElement

    formData["supplier"] = {
      name: supplierNameInput ? supplierNameInput.value : "",
      date: supplierDateInput ? supplierDateInput.value : "",
      legal_rappresentative_name: supplierLegalRepresentativeInput ? supplierLegalRepresentativeInput.value : "",
      legal_rappresentative_signature: supplierLegalRepresentativeSignatureInput
        ? supplierLegalRepresentativeSignatureInput.value
        : "",
      position_within_company: supplierPositionWithinCompanyInput ? supplierPositionWithinCompanyInput.value : ""
    }
    return formData
  }

  private collectStepPlantUtilitiesData(): { [key: string]: any } {
    const plantUtilitiesData = document.querySelector(`input[name="plant_utilities"]`) as HTMLInputElement

    let plantData = plantUtilitiesData ? JSON.parse(plantUtilitiesData.value) : {}

    // Rimuovo le proprietà non necessarie
    if (typeof plantData === "object" && plantData !== null) {
      // Esempio: rimuovi proprietà che non servono
      delete plantData.created_at
      delete plantData.updated_at
      delete plantData.deleted
    }

    return plantData
  }

  /**
   * Raccolta dati specifici per Step 4 - Safety and Ergonomics Conformity
   */
  private collectStepSafetyErgonomics(): { [key: string]: any } {
    const fieldNames = [
      // New Equipment
      "machinery_regulation",
      "ce_marking",
      "nis2_directive",
      "cyber_resilience_act",
      "certification_area",
      "low_voltage",
      "pressure_equipment",
      "atex",
      // Existing Equipment
      "new_ce_marking",
      "ce_requalification",
      "maintenance_activities",
      // Risk Analysis
      "machine_safety",
      "noise_level",
      // Ergonomics
      "ergonomics_specs",
      "workplace_architecture",
      "manual_handling",
      "force",
      "posture",
      "low_loads_handling"
    ]

    const formData: { [key: string]: any } = {}

    console.log("Collecting Step 4 form data...")

    fieldNames.forEach(fieldName => {
      const appliedSelect = document.querySelector(`select[name="${fieldName}"]`) as HTMLSelectElement
      const notesTextarea = document.querySelector(`textarea[name="${fieldName}_note"]`) as HTMLTextAreaElement

      console.log(`Field ${fieldName}:`, {
        applied: appliedSelect ? appliedSelect.value : "NOT FOUND",
        notes: notesTextarea ? notesTextarea.value : "NOT FOUND"
      })

      formData[fieldName] = {
        applied: appliedSelect ? appliedSelect.value : "",
        notes: notesTextarea ? notesTextarea.value : ""
      }
    })

    console.log("Collected Step 4 data:", formData)
    return formData
  }

  /**
   * Raccolta dati specifici per Step 5 - Components
   */
  private $collectStepComponents(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}

    console.log("Collecting Step 5 form data...")

    // Gestione HMI
    const hmiBrandTypeInput = document.querySelector(`input[name="hmi_brand_type"]`) as HTMLInputElement
    const hmiNotesTextarea = document.querySelector(`textarea[name="hmi_note"]`) as HTMLTextAreaElement

    console.log(`Component hmi:`, {
      brand_type: hmiBrandTypeInput ? hmiBrandTypeInput.value : "NOT FOUND",
      notes: hmiNotesTextarea ? hmiNotesTextarea.value : "NOT FOUND"
    })

    formData["hmi"] = {
      brand_type: hmiBrandTypeInput ? hmiBrandTypeInput.value : "",
      notes: hmiNotesTextarea ? hmiNotesTextarea.value : ""
    }

    // Gestione Pushbuttons
    const pushbuttonsBrandTypeInput = document.querySelector(`input[name="pushbuttons_brand_type"]`) as HTMLInputElement
    const pushbuttonsNotesTextarea = document.querySelector(`textarea[name="pushbuttons_note"]`) as HTMLTextAreaElement

    console.log(`Component pushbuttons:`, {
      brand_type: pushbuttonsBrandTypeInput ? pushbuttonsBrandTypeInput.value : "NOT FOUND",
      notes: pushbuttonsNotesTextarea ? pushbuttonsNotesTextarea.value : "NOT FOUND"
    })

    formData["pushbuttons"] = {
      brand_type: pushbuttonsBrandTypeInput ? pushbuttonsBrandTypeInput.value : "",
      notes: pushbuttonsNotesTextarea ? pushbuttonsNotesTextarea.value : ""
    }

    // Gestione CNC
    const cncBrandTypeInput = document.querySelector(`input[name="cnc_brand_type"]`) as HTMLInputElement
    const cncNotesTextarea = document.querySelector(`textarea[name="cnc_note"]`) as HTMLTextAreaElement

    console.log(`Component cnc:`, {
      brand_type: cncBrandTypeInput ? cncBrandTypeInput.value : "NOT FOUND",
      notes: cncNotesTextarea ? cncNotesTextarea.value : "NOT FOUND"
    })

    formData["cnc"] = {
      brand_type: cncBrandTypeInput ? cncBrandTypeInput.value : "",
      notes: cncNotesTextarea ? cncNotesTextarea.value : ""
    }

    // Gestione PLC
    const plcBrandTypeInput = document.querySelector(`input[name="plc_brand_type"]`) as HTMLInputElement
    const plcNotesTextarea = document.querySelector(`textarea[name="plc_note"]`) as HTMLTextAreaElement

    console.log(`Component plc:`, {
      brand_type: plcBrandTypeInput ? plcBrandTypeInput.value : "NOT FOUND",
      notes: plcNotesTextarea ? plcNotesTextarea.value : "NOT FOUND"
    })

    formData["plc"] = {
      brand_type: plcBrandTypeInput ? plcBrandTypeInput.value : "",
      notes: plcNotesTextarea ? plcNotesTextarea.value : ""
    }

    // Gestione Network Switch
    const networkSwitchBrandTypeInput = document.querySelector(
      `input[name="network_switch_brand_type"]`
    ) as HTMLInputElement
    const networkSwitchNotesTextarea = document.querySelector(
      `textarea[name="network_switch_note"]`
    ) as HTMLTextAreaElement

    console.log(`Component network_switch:`, {
      brand_type: networkSwitchBrandTypeInput ? networkSwitchBrandTypeInput.value : "NOT FOUND",
      notes: networkSwitchNotesTextarea ? networkSwitchNotesTextarea.value : "NOT FOUND"
    })

    formData["network_switch"] = {
      brand_type: networkSwitchBrandTypeInput ? networkSwitchBrandTypeInput.value : "",
      notes: networkSwitchNotesTextarea ? networkSwitchNotesTextarea.value : ""
    }

    // Gestione Robot
    const robotBrandTypeInput = document.querySelector(`input[name="robot_brand_type"]`) as HTMLInputElement
    const robotNotesTextarea = document.querySelector(`textarea[name="robot_note"]`) as HTMLTextAreaElement

    console.log(`Component robot:`, {
      brand_type: robotBrandTypeInput ? robotBrandTypeInput.value : "NOT FOUND",
      notes: robotNotesTextarea ? robotNotesTextarea.value : "NOT FOUND"
    })

    formData["robot"] = {
      brand_type: robotBrandTypeInput ? robotBrandTypeInput.value : "",
      notes: robotNotesTextarea ? robotNotesTextarea.value : ""
    }

    // Gestione Marking Pin
    const markingPinBrandTypeInput = document.querySelector(`input[name="marking_pin_brand_type"]`) as HTMLInputElement
    const markingPinNotesTextarea = document.querySelector(`textarea[name="marking_pin_note"]`) as HTMLTextAreaElement

    formData["marking_pin"] = {
      brand_type: markingPinBrandTypeInput ? markingPinBrandTypeInput.value : "",
      notes: markingPinNotesTextarea ? markingPinNotesTextarea.value : ""
    }

    // Gestione Label Printer
    const labelPrinterBrandTypeInput = document.querySelector(
      `input[name="label_printer_brand_type"]`
    ) as HTMLInputElement
    const labelPrinterNotesTextarea = document.querySelector(
      `textarea[name="label_printer_note"]`
    ) as HTMLTextAreaElement

    formData["label_printer"] = {
      brand_type: labelPrinterBrandTypeInput ? labelPrinterBrandTypeInput.value : "",
      notes: labelPrinterNotesTextarea ? labelPrinterNotesTextarea.value : ""
    }

    // Gestione Vision System (usa "brand" invece di "brand_type")
    const visionSystemBrandTypeInput = document.querySelector(
      `input[name="vision_system_brand_type"]`
    ) as HTMLInputElement
    const visionSystemNotesTextarea = document.querySelector(
      `textarea[name="vision_system_note"]`
    ) as HTMLTextAreaElement

    formData["vision_system"] = {
      brand_type: visionSystemBrandTypeInput ? visionSystemBrandTypeInput.value : "",
      notes: visionSystemNotesTextarea ? visionSystemNotesTextarea.value : ""
    }

    // Gestione Laser Marking
    const laserMarkingBrandTypeInput = document.querySelector(
      `input[name="laser_marking_brand_type"]`
    ) as HTMLInputElement
    const laserMarkingNotesTextarea = document.querySelector(
      `textarea[name="laser_marking_note"]`
    ) as HTMLTextAreaElement

    formData["laser_marking"] = {
      brand_type: laserMarkingBrandTypeInput ? laserMarkingBrandTypeInput.value : "",
      notes: laserMarkingNotesTextarea ? laserMarkingNotesTextarea.value : ""
    }

    // Gestione Code Reader
    const codeReaderBrandTypeInput = document.querySelector(`input[name="code_reader_brand_type"]`) as HTMLInputElement
    const codeReaderNotesTextarea = document.querySelector(`textarea[name="code_reader_note"]`) as HTMLTextAreaElement

    formData["code_reader"] = {
      brand_type: codeReaderBrandTypeInput ? codeReaderBrandTypeInput.value : "",
      notes: codeReaderNotesTextarea ? codeReaderNotesTextarea.value : ""
    }

    // Gestione Pneumatic
    const pneumaticBrandTypeInput = document.querySelector(`input[name="pneumatic_brand_type"]`) as HTMLInputElement
    const pneumaticNotesTextarea = document.querySelector(`textarea[name="pneumatic_note"]`) as HTMLTextAreaElement

    formData["pneumatic"] = {
      brand_type: pneumaticBrandTypeInput ? pneumaticBrandTypeInput.value : "",
      notes: pneumaticNotesTextarea ? pneumaticNotesTextarea.value : ""
    }

    // Gestione Hydraulic
    const hydraulicBrandTypeInput = document.querySelector(`input[name="hydraulic_brand_type"]`) as HTMLInputElement
    const hydraulicNotesTextarea = document.querySelector(`textarea[name="hydraulic_note"]`) as HTMLTextAreaElement

    formData["hydraulic"] = {
      brand_type: hydraulicBrandTypeInput ? hydraulicBrandTypeInput.value : "",
      notes: hydraulicNotesTextarea ? hydraulicNotesTextarea.value : ""
    }

    // Gestione Lubrication
    const lubricationBrandTypeInput = document.querySelector(`input[name="lubrication_brand_type"]`) as HTMLInputElement
    const lubricationNotesTextarea = document.querySelector(`textarea[name="lubrication_note"]`) as HTMLTextAreaElement

    formData["lubrication"] = {
      brand_type: lubricationBrandTypeInput ? lubricationBrandTypeInput.value : "",
      notes: lubricationNotesTextarea ? lubricationNotesTextarea.value : ""
    }

    // Gestione Cooling System
    const coolingSystemBrandTypeInput = document.querySelector(
      `input[name="cooling_system_brand_type"]`
    ) as HTMLInputElement
    const coolingSystemNotesTextarea = document.querySelector(
      `textarea[name="cooling_system_note"]`
    ) as HTMLTextAreaElement

    formData["cooling_system"] = {
      brand_type: coolingSystemBrandTypeInput ? coolingSystemBrandTypeInput.value : "",
      notes: coolingSystemNotesTextarea ? coolingSystemNotesTextarea.value : ""
    }

    // Gestione Electromechanic
    const electromechanicBrandTypeInput = document.querySelector(
      `input[name="electromechanic_brand_type"]`
    ) as HTMLInputElement
    const electromechanicNotesTextarea = document.querySelector(
      `textarea[name="electromechanic_note"]`
    ) as HTMLTextAreaElement

    formData["electromechanic"] = {
      brand_type: electromechanicBrandTypeInput ? electromechanicBrandTypeInput.value : "",
      notes: electromechanicNotesTextarea ? electromechanicNotesTextarea.value : ""
    }

    // Gestione Tightening System
    const tighteningSystemBrandTypeInput = document.querySelector(
      `input[name="tightening_system_brand_type"]`
    ) as HTMLInputElement
    const tighteningSystemNotesTextarea = document.querySelector(
      `textarea[name="tightening_system_note"]`
    ) as HTMLTextAreaElement

    formData["tightening_system"] = {
      brand_type: tighteningSystemBrandTypeInput ? tighteningSystemBrandTypeInput.value : "",
      notes: tighteningSystemNotesTextarea ? tighteningSystemNotesTextarea.value : ""
    }

    // Gestione Electromechanical Presses
    const electromechanicalPressesBrandTypeInput = document.querySelector(
      `input[name="electromechanical_presses_brand_type"]`
    ) as HTMLInputElement
    const electromechanicalPressesNotesTextarea = document.querySelector(
      `textarea[name="electromechanical_presses_note"]`
    ) as HTMLTextAreaElement

    formData["electromechanical_presses"] = {
      brand_type: electromechanicalPressesBrandTypeInput ? electromechanicalPressesBrandTypeInput.value : "",
      notes: electromechanicalPressesNotesTextarea ? electromechanicalPressesNotesTextarea.value : ""
    }

    // Gestione Arc Welding
    const arcWeldingBrandTypeInput = document.querySelector(`input[name="arc_welding_brand_type"]`) as HTMLInputElement
    const arcWeldingNotesTextarea = document.querySelector(`textarea[name="arc_welding_note"]`) as HTMLTextAreaElement

    formData["arc_welding"] = {
      brand_type: arcWeldingBrandTypeInput ? arcWeldingBrandTypeInput.value : "",
      notes: arcWeldingNotesTextarea ? arcWeldingNotesTextarea.value : ""
    }

    // Gestione Spot Welding
    const spotWeldingBrandTypeInput = document.querySelector(
      `input[name="spot_welding_brand_type"]`
    ) as HTMLInputElement
    const spotWeldingNotesTextarea = document.querySelector(`textarea[name="spot_welding_note"]`) as HTMLTextAreaElement

    console.log(`Component spot_welding:`, {
      brand_type: spotWeldingBrandTypeInput ? spotWeldingBrandTypeInput.value : "NOT FOUND",
      notes: spotWeldingNotesTextarea ? spotWeldingNotesTextarea.value : "NOT FOUND"
    })

    formData["spot_welding"] = {
      brand_type: spotWeldingBrandTypeInput ? spotWeldingBrandTypeInput.value : "",
      notes: spotWeldingNotesTextarea ? spotWeldingNotesTextarea.value : ""
    }

    // Gestione Gun Spot Welding
    const gunSpotWeldingBrandTypeInput = document.querySelector(
      `input[name="gun_spot_welding_brand_type"]`
    ) as HTMLInputElement
    const gunSpotWeldingNotesTextarea = document.querySelector(
      `textarea[name="gun_spot_welding_note"]`
    ) as HTMLTextAreaElement

    formData["gun_spot_welding"] = {
      brand_type: gunSpotWeldingBrandTypeInput ? gunSpotWeldingBrandTypeInput.value : "",
      notes: gunSpotWeldingNotesTextarea ? gunSpotWeldingNotesTextarea.value : ""
    }

    console.log("Collected Step 5 data:", formData)
    return formData
  }

  /**
   * Raccolta dati specifici per Step 6 - Deviation Request
   */
  private $collectStepDeviationRequest(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}

    console.log("Collecting Step 6 form data...")

    // Raccolta di tutte le richieste multiple
    const requestItems = document.querySelectorAll(".deviation-request-item")
    const requests: any[] = []

    requestItems.forEach((item, index) => {
      const reasonTypeSelect = item.querySelector(`select[name="requests[${index}][reason_type]"]`) as HTMLSelectElement
      const requestTextarea = item.querySelector(`textarea[name="requests[${index}][request]"]`) as HTMLTextAreaElement
      const commentTextarea = item.querySelector(`textarea[name="requests[${index}][comment]"]`) as HTMLTextAreaElement

      const requestData = {
        reason_type: reasonTypeSelect ? reasonTypeSelect.value : "",
        request: requestTextarea ? requestTextarea.value : "",
        comment: commentTextarea ? commentTextarea.value : ""
      }

      requests.push(requestData)
    })

    formData["requests"] = requests

    console.log("Collected Step 6 data:", formData)
    return formData
  }

  /**
   * Raccolta dati specifici per Step 7 - Technical efficiency
   */
  private collectStepTechicalEfficiency(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}

    console.log("Collecting Step Technical Efficiency form data...")

    // Campi obbligatori di base
    const hoursPerShiftInput = document.querySelector(`input[name="hours_per_shift"]`) as HTMLInputElement
    const shiftsPerDayInput = document.querySelector(`input[name="shifts_per_day"]`) as HTMLInputElement
    const workingDaysYearInput = document.querySelector(`input[name="working_days_year"]`) as HTMLInputElement
    const workingHoursYearInput = document.querySelector(`input[name="working_hours_year"]`) as HTMLInputElement

    formData["project_details"] = {
      hours_per_shift: hoursPerShiftInput ? hoursPerShiftInput.value : "",
      shifts_per_day: shiftsPerDayInput ? shiftsPerDayInput.value : "",
      working_days_year: workingDaysYearInput ? workingDaysYearInput.value : "",
      working_hours_year: workingHoursYearInput ? workingHoursYearInput.value : ""
    }

    const activeMachineTimeInput = document.querySelector(`input[name="active_machine_time"]`) as HTMLInputElement
    const inactiveMachineTimeInput = document.querySelector(`input[name="inactive_machine_time"]`) as HTMLInputElement

    formData["active_machine_time"] = activeMachineTimeInput ? activeMachineTimeInput.value : ""
    formData["inactive_machine_time"] = inactiveMachineTimeInput ? inactiveMachineTimeInput.value : ""

    // Wheel dressing fields per 3 ruote
    for (let i = 1; i <= 3; i++) {
      const frequencyInput = document.querySelector(`input[name="wheel${i}_frequency"]`) as HTMLInputElement
      const timeInput = document.querySelector(`input[name="wheel${i}_time"]`) as HTMLInputElement
      const dressingPerPieceInput = document.querySelector(
        `input[name="wheel${i}_dressing_per_piece"]`
      ) as HTMLInputElement

      formData[`wheel${i}_frequency`] = frequencyInput ? frequencyInput.value : ""
      formData[`wheel${i}_time`] = timeInput ? timeInput.value : ""
      formData[`wheel${i}_dressing_per_piece`] = dressingPerPieceInput ? dressingPerPieceInput.value : ""
    }

    // N° pieces processed simultaneously
    const piecesSimultaneousInput = document.querySelector(`input[name="pieces_simultaneous"]`) as HTMLInputElement
    formData["pieces_simultaneous"] = piecesSimultaneousInput ? piecesSimultaneousInput.value : ""

    // Raccogliamo anche i campi readonly calcolati automaticamente
    const totalDressingTimeInput = document.querySelector(`input[name="total_dressing_time"]`) as HTMLInputElement
    const totalMachineTimeInput = document.querySelector(`input[name="total_machine_time"]`) as HTMLInputElement
    const equivalentMachineTimeInput = document.querySelector(
      `input[name="equivalent_machine_time"]`
    ) as HTMLInputElement
    const hourlyOutputInput = document.querySelector(
      `input[name="machine_time_cycle_operation_hourly_output"]`
    ) as HTMLInputElement

    formData["total_dressing_time"] = totalDressingTimeInput ? totalDressingTimeInput.value : ""
    formData["total_machine_time"] = totalMachineTimeInput ? totalMachineTimeInput.value : ""
    formData["equivalent_machine_time"] = equivalentMachineTimeInput ? equivalentMachineTimeInput.value : ""
    formData["machine_time_cycle_operation_hourly_output"] = hourlyOutputInput ? hourlyOutputInput.value : ""

    const cycleOperationStandstillInput = document.querySelector(
      `input[name="cycle_operation_standstill"]`
    ) as HTMLInputElement
    formData["cycle_operation_standstill"] = cycleOperationStandstillInput ? cycleOperationStandstillInput.value : ""

    const toolChangeAveragePeriodInput = document.querySelector(
      `input[name="tool_change_average_period"]`
    ) as HTMLInputElement
    formData["tool_change_average_period"] = toolChangeAveragePeriodInput ? toolChangeAveragePeriodInput.value : ""

    const toolChangeAverageTimeInput = document.querySelector(
      `input[name="tool_change_average_time"]`
    ) as HTMLInputElement
    formData["tool_change_average_time"] = toolChangeAverageTimeInput ? toolChangeAverageTimeInput.value : ""

    const toolChangeWorkersInput = document.querySelector(`input[name="tool_change_workers"]`) as HTMLInputElement
    formData["tool_change_workers"] = toolChangeWorkersInput ? toolChangeWorkersInput.value : ""

    const toolChangePieceIncidenceInput = document.querySelector(
      `input[name="tool_change_piece_incidence"]`
    ) as HTMLInputElement
    formData["tool_change_piece_incidence"] = toolChangePieceIncidenceInput ? toolChangePieceIncidenceInput.value : ""

    const toolChangeEfficiencyInput = document.querySelector(
      `input[name="tool_change_efficiency_percentage"]`
    ) as HTMLInputElement
    formData["tool_change_efficiency_percentage"] = toolChangeEfficiencyInput ? toolChangeEfficiencyInput.value : ""

    // Other activities fields
    const otherActivitiesAveragePeriodInput = document.querySelector(
      `input[name="other_activities_average_period"]`
    ) as HTMLInputElement
    formData["other_activities_average_period"] = otherActivitiesAveragePeriodInput
      ? otherActivitiesAveragePeriodInput.value
      : ""

    const otherActivitiesAverageTimeInput = document.querySelector(
      `input[name="other_activities_average_time"]`
    ) as HTMLInputElement
    formData["other_activities_average_time"] = otherActivitiesAverageTimeInput
      ? otherActivitiesAverageTimeInput.value
      : ""

    const otherActivitiesWorkersInput = document.querySelector(
      `input[name="other_activities_workers"]`
    ) as HTMLInputElement
    formData["other_activities_workers"] = otherActivitiesWorkersInput ? otherActivitiesWorkersInput.value : ""

    const otherActivitiesPieceIncidenceInput = document.querySelector(
      `input[name="other_activities_piece_incidence"]`
    ) as HTMLInputElement
    formData["other_activities_piece_incidence"] = otherActivitiesPieceIncidenceInput
      ? otherActivitiesPieceIncidenceInput.value
      : ""

    const otherActivitiesEfficiencyInput = document.querySelector(
      `input[name="other_activities_efficiency_percentage"]`
    ) as HTMLInputElement
    formData["other_activities_efficiency_percentage"] = otherActivitiesEfficiencyInput
      ? otherActivitiesEfficiencyInput.value
      : ""

    // Scheduled maintenance fields
    const scheduledMaintenanceAveragePeriodInput = document.querySelector(
      `input[name="scheduled_maintenance_average_period"]`
    ) as HTMLInputElement
    formData["scheduled_maintenance_average_period"] = scheduledMaintenanceAveragePeriodInput
      ? scheduledMaintenanceAveragePeriodInput.value
      : ""

    const scheduledMaintenanceAverageTimeInput = document.querySelector(
      `input[name="scheduled_maintenance_average_time"]`
    ) as HTMLInputElement
    formData["scheduled_maintenance_average_time"] = scheduledMaintenanceAverageTimeInput
      ? scheduledMaintenanceAverageTimeInput.value
      : ""

    const scheduledMaintenanceWorkersInput = document.querySelector(
      `input[name="scheduled_maintenance_workers"]`
    ) as HTMLInputElement
    formData["scheduled_maintenance_workers"] = scheduledMaintenanceWorkersInput
      ? scheduledMaintenanceWorkersInput.value
      : ""

    const scheduledMaintenancePieceIncidenceInput = document.querySelector(
      `input[name="scheduled_maintenance_piece_incidence"]`
    ) as HTMLInputElement
    formData["scheduled_maintenance_piece_incidence"] = scheduledMaintenancePieceIncidenceInput
      ? scheduledMaintenancePieceIncidenceInput.value
      : ""

    const scheduledMaintenanceEfficiencyInput = document.querySelector(
      `input[name="scheduled_maintenance_efficiency_percentage"]`
    ) as HTMLInputElement
    formData["scheduled_maintenance_efficiency_percentage"] = scheduledMaintenanceEfficiencyInput
      ? scheduledMaintenanceEfficiencyInput.value
      : ""

    // Malfunctions fields
    const malfunctionsMtbfInput = document.querySelector(`input[name="malfunctions_mtbf"]`) as HTMLInputElement
    formData["malfunctions_mtbf"] = malfunctionsMtbfInput ? malfunctionsMtbfInput.value : ""

    const malfunctionsMttrInput = document.querySelector(`input[name="malfunctions_mttr"]`) as HTMLInputElement
    formData["malfunctions_mttr"] = malfunctionsMttrInput ? malfunctionsMttrInput.value : ""

    const malfunctionsPieceIncidenceInput = document.querySelector(
      `input[name="malfunctions_piece_incidence"]`
    ) as HTMLInputElement
    formData["malfunctions_piece_incidence"] = malfunctionsPieceIncidenceInput
      ? malfunctionsPieceIncidenceInput.value
      : ""

    const malfunctionsEfficiencyInput = document.querySelector(
      `input[name="malfunctions_efficiency_percentage"]`
    ) as HTMLInputElement
    formData["malfunctions_efficiency_percentage"] = malfunctionsEfficiencyInput
      ? malfunctionsEfficiencyInput.value
      : ""

    const malfunctionsTtrmaxInput = document.querySelector(`input[name="malfunctions_ttrmax"]`) as HTMLInputElement
    formData["malfunctions_ttrmax"] = malfunctionsTtrmaxInput ? malfunctionsTtrmaxInput.value : ""

    // Technical Efficiency field
    const technicalEfficiencyInput = document.querySelector(`input[name="technical_efficiency"]`) as HTMLInputElement
    formData["technical_efficiency"] = technicalEfficiencyInput ? technicalEfficiencyInput.value : ""

    // Final Hourly Output field
    const finalHourlyOutputInput = document.querySelector(`input[name="hourly_output"]`) as HTMLInputElement
    formData["hourly_output"] = finalHourlyOutputInput ? finalHourlyOutputInput.value : ""

    // Type Change fields
    const scheduledTimeTypeChangeInput = document.querySelector(
      `input[name="scheduled_time_type_change"]`
    ) as HTMLInputElement
    formData["scheduled_time_type_change"] = scheduledTimeTypeChangeInput ? scheduledTimeTypeChangeInput.value : ""

    const employedWorkersInput = document.querySelector(`input[name="employed_workers"]`) as HTMLInputElement
    formData["employed_workers"] = employedWorkersInput ? employedWorkersInput.value : ""

    console.log("Collected Step Technical Efficiency data:", formData)
    return formData
  }

  /**
   * Raccolta dati specifici per Step 8 - Running Costs
   */
  private $collectStepRunningCosts(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}

    console.log("Collecting Step 8 form data...")

    // Campi Running Costs
    const energyConsumptionNotWorkingInput = document.querySelector(
      `input[name="energy_consumption_not_working"]`
    ) as HTMLInputElement
    const energyConsumptionWorkingInput = document.querySelector(
      `input[name="energy_consumption_working"]`
    ) as HTMLInputElement
    const airConsumptionNotWorkingInput = document.querySelector(
      `input[name="air_consumption_not_working"]`
    ) as HTMLInputElement
    const airConsumptionWorkingInput = document.querySelector(
      `input[name="air_consumption_working"]`
    ) as HTMLInputElement
    const lubricationConsumptionInput = document.querySelector(
      `input[name="lubrication_consumption"]`
    ) as HTMLInputElement
    const sparePartsInput = document.querySelector(`input[name="spare_parts"]`) as HTMLInputElement
    const maintenanceMachineOperatorInput = document.querySelector(
      `input[name="maintenance_machine_operator"]`
    ) as HTMLInputElement

    formData["running_costs"] = {
      energy_consumption_not_working: energyConsumptionNotWorkingInput ? energyConsumptionNotWorkingInput.value : "",
      energy_consumption_working: energyConsumptionWorkingInput ? energyConsumptionWorkingInput.value : "",
      air_consumption_not_working: airConsumptionNotWorkingInput ? airConsumptionNotWorkingInput.value : "",
      air_consumption_working: airConsumptionWorkingInput ? airConsumptionWorkingInput.value : "",
      lubrication_consumption: lubricationConsumptionInput ? lubricationConsumptionInput.value : "",
      spare_parts: sparePartsInput ? sparePartsInput.value : "",
      maintenance_machine_operator: maintenanceMachineOperatorInput ? maintenanceMachineOperatorInput.value : ""
    }

    console.log("Collected Step 8 data:", formData)
    return formData
  }

  /**
   * Raccolta dati specifici per Step 9 - Energy Assessment
   */
  private $collectStepEnergyAssesment(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}

    console.log("Collecting Step 9 form data...")

    // Energy Assessment fields
    const installedPowerInput = document.querySelector(`input[name="installed_power"]`) as HTMLInputElement
    const averagePowerAbsorbedInput = document.querySelector(`input[name="average_power_absorbed"]`) as HTMLInputElement
    const powerFactorInput = document.querySelector(`input[name="power_factor"]`) as HTMLInputElement
    const hourlyConsumptionCompressedAirInput = document.querySelector(
      `input[name="hourly_consumption_compressed_air"]`
    ) as HTMLInputElement
    const hourlyConsumptionMethaneInput = document.querySelector(
      `input[name="hourly_consumption_methane"]`
    ) as HTMLInputElement
    const hourlyConsumptionIndustrialWaterInput = document.querySelector(
      `input[name="hourly_consumption_industrial_water"]`
    ) as HTMLInputElement
    const hourlyConsumptionCoolantInput = document.querySelector(
      `input[name="hourly_consumption_coolant"]`
    ) as HTMLInputElement

    formData["energy_assessment"] = {
      installed_power: installedPowerInput ? installedPowerInput.value : "",
      average_power_absorbed: averagePowerAbsorbedInput ? averagePowerAbsorbedInput.value : "",
      power_factor: powerFactorInput ? powerFactorInput.value : "",
      hourly_consumption_compressed_air: hourlyConsumptionCompressedAirInput
        ? hourlyConsumptionCompressedAirInput.value
        : "",
      hourly_consumption_methane: hourlyConsumptionMethaneInput ? hourlyConsumptionMethaneInput.value : "",
      hourly_consumption_industrial_water: hourlyConsumptionIndustrialWaterInput
        ? hourlyConsumptionIndustrialWaterInput.value
        : "",
      hourly_consumption_coolant: hourlyConsumptionCoolantInput ? hourlyConsumptionCoolantInput.value : ""
    }

    console.log("Collected Step 9 data:", formData)
    return formData
  }

  /**
   * Raccolta dati specifici per Step 10 - Maintenance Time
   */
  private $collectStepMaintenanceTime(): { [key: string]: any } {
    const formData: { [key: string]: any } = {}

    console.log("Collecting Step 10 form data...")

    // Maintenance Time fields
    const maintenanceOperatorInput = document.querySelector(`input[name="maintenance_operator"]`) as HTMLInputElement
    const maintenanceOperatorMachineNotRunningInput = document.querySelector(
      `input[name="maintenance_operator_machine_not_running"]`
    ) as HTMLInputElement
    const maintenanceOperatorMachineRunningInput = document.querySelector(
      `input[name="maintenance_operator_machine_running"]`
    ) as HTMLInputElement
    const sparePartsCostInput = document.querySelector(`input[name="spare_parts_cost"]`) as HTMLInputElement

    formData["maintenance_time"] = {
      maintenance_operator: maintenanceOperatorInput ? maintenanceOperatorInput.value : "",
      maintenance_operator_machine_not_running: maintenanceOperatorMachineNotRunningInput
        ? maintenanceOperatorMachineNotRunningInput.value
        : "",
      maintenance_operator_machine_running: maintenanceOperatorMachineRunningInput
        ? maintenanceOperatorMachineRunningInput.value
        : "",
      spare_parts_cost: sparePartsCostInput ? sparePartsCostInput.value : ""
    }

    console.log("Collected Step 10 data:", formData)
    return formData
  }
}
